 if($('.master-slider').length>0){
	   window.averta = {},
	     function(t) {
	         function i(t) {
	             var i, e = (document.body || document.documentElement).style, s = t;
	             if ("string" == typeof e[s])
	                 return !0;
	             for (v = ["Moz", "Webkit", "Khtml", "O", "ms"],
	                      s = s.charAt(0).toUpperCase() + s.substr(1),
	                      i = 0; i < v.length; i++)
	                 if ("string" == typeof e[v[i] + s])
	                     return !0;
	             return !1
	         }
	         function e() {
	             return i("transform")
	         }
	         var s, n;
	         window.package = function(t) {
	             window[t] || (window[t] = {})
	         }
             ,
             s = function(t, i) {
                 for (var e in i)
                     t[e] = i[e]
             }
             ,
             Function.prototype.extend = function(t) {
                 "function" == typeof t.prototype.constructor ? (s(this.prototype, t.prototype),
                     this.prototype.constructor = this) : (this.prototype.extend(t),
                     this.prototype.constructor = this)
             }
             ,
             n = {
                 Moz: "-moz-",
                 Webkit: "-webkit-",
                 Khtml: "-khtml-",
                 O: "-o-",
                 ms: "-ms-",
                 Icab: "-icab-"
             },
             t(document).ready((function() {
                     window._jcsspfx = function() {
                         var t, i, e;
                         if ("result"in arguments.callee)
                             return arguments.callee.result;
                         for (e in t = /^(Moz|Webkit|Khtml|O|ms|Icab)(?=[A-Z])/,
                             (i = document.getElementsByTagName("script")[0]).style)
                             if (t.test(e))
                                 return arguments.callee.result = e.match(t)[0];
                         return arguments.callee.result = "WebkitOpacity"in i.style ? "Webkit" : "KhtmlOpacity"in i.style ? "Khtml" : ""
                     }(),
                         window._csspfx = n[window._jcsspfx],
                         window._cssanim = i("transition"),
                         window._css3d = function() {
                             var t, i, s, n;
                             if (!e())
                                 return !1;
                             for (n in t = document.createElement("p"),
                                 s = {
                                     WebkitTransform: "-webkit-transform",
                                     OTransform: "-o-transform",
                                     MSTransform: "-ms-transform",
                                     msTransform: "-ms-transform",
                                     MozTransform: "-moz-transform",
                                     Transform: "transform",
                                     transform: "transform"
                                 },
                                 document.body.insertBefore(t, null),
                                 s)
                                 void 0 !== t.style[n] && (t.style[n] = "translate3d(1px,1px,1px)",
                                     i = window.getComputedStyle(t).getPropertyValue(s[n]));
                             return document.body.removeChild(t),
                             null != i && i.length > 0 && "none" !== i
                         }(),
                         window._css2d = e(),
                         window._mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                         window._touch = "ontouchstart"in document
                 }
             )),
             window.parseQueryString = function(t) {
                 var i = {};
                 return t.replace(new RegExp("([^?=&]+)(=([^&]*))?","g"), (function(t, e, s, n) {
                         i[e] = n
                     }
                 )),
                     i
             }
             ,
         window.requestAnimationFrame || (window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(t) {
                 window.setTimeout(t, 16.666666666666668)
             }
         ),
         window.getComputedStyle || (window.getComputedStyle = function(t) {
                 return this.el = t,
                     this.getPropertyValue = function(i) {
                         var e = /(\-([a-z]){1})/g;
                         return "float" == i && (i = "styleFloat"),
                         e.test(i) && (i = i.replace(e, (function() {
                                 return arguments[2].toUpperCase()
                             }
                         ))),
                             t.currentStyle[i] ? t.currentStyle[i] : null
                     }
                     ,
                     t.currentStyle
             }
         ),
         Array.prototype.indexOf || (Array.prototype.indexOf = function(t) {
                 var i = this.length >>> 0
                     , e = Number(arguments[1]) || 0;
                 for ((e = e < 0 ? Math.ceil(e) : Math.floor(e)) < 0 && (e += i); e < i; e++)
                     if (e in this && this[e] === t)
                         return e;
                 return -1
             }
         ),
         jQuery && (t.jqLoadFix = function() {
                 if (this.complete) {
                     var i = this;
                     setTimeout((function() {
                             t(i).load()
                         }
                     ), 1)
                 }
             }
                 ,
                 jQuery.uaMatch = jQuery.uaMatch || function(t) {
                     t = t.toLowerCase();
                     var i = /(chrome)[ \/]([\w.]+)/.exec(t) || /(webkit)[ \/]([\w.]+)/.exec(t) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(t) || /(msie) ([\w.]+)/.exec(t) || t.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(t) || [];
                     return {
                         browser: i[1] || "",
                         version: i[2] || "0"
                     }
                 }
                 ,
                 matched = jQuery.uaMatch(navigator.userAgent),
                 browser = {},
             matched.browser && (browser[matched.browser] = !0,
                 browser.version = matched.version),
                 browser.chrome ? browser.webkit = !0 : browser.webkit && (browser.safari = !0),
             !!navigator.userAgent.match(/Trident\/7\./) && (browser.msie = "true",
                 delete browser.mozilla),
                 jQuery.browser = browser,
                 t.fn.preloadImg = function(i, e) {
                     return this.each((function() {
                             var s = t(this)
                                 , n = this
                                 , o = new Image;
                             o.onload = function(t) {
                                 null == t && (t = {}),
                                     s.attr("src", i),
                                     t.width = o.width,
                                     t.height = o.height,
                                     setTimeout((function() {
                                             e.call(n, t)
                                         }
                                     ), 50),
                                     o = null
                             }
                                 ,
                                 o.src = i
                         }
                     )),
                         this
                 }
         )
     }(jQuery),
     function() {
         "use strict";
         averta.EventDispatcher = function() {
             this.listeners = {}
         }
             ,
             averta.EventDispatcher.extend = function(t) {
                 var i, e = new averta.EventDispatcher;
                 for (i in e)
                     "constructor" != i && (t[i] = averta.EventDispatcher.prototype[i])
             }
             ,
             averta.EventDispatcher.prototype = {
                 constructor: averta.EventDispatcher,
                 addEventListener: function(t, i, e) {
                     this.listeners[t] || (this.listeners[t] = []),
                         this.listeners[t].push({
                             listener: i,
                             ref: e
                         })
                 },
                 removeEventListener: function(t, i, e) {
                     if (this.listeners[t]) {
                         for (var s = 0, n = this.listeners[t].length; s < n; ++s)
                             i == this.listeners[t][s].listener && e == this.listeners[t][s].ref && this.listeners[t].splice(s);
                         0 == this.listeners[t].length && delete this.listeners[t]
                     }
                 },
                 dispatchEvent: function(t) {
                     if (t.target = this,
                         this.listeners[t.type])
                         for (var i = 0, e = this.listeners[t.type].length; i < e; ++i)
                             this.listeners[t.type][i].listener.call(this.listeners[t.type][i].ref, t)
                 }
             }
     }(),
     function(t) {
         "use strict";
         var i, e = "ontouchstart"in document, s = e ? "touchstart" : "mousedown", n = e ? "touchmove" : "mousemove", o = e ? "touchend" : "mouseup", a = "touchcancel";
         averta.TouchSwipe = function(t) {
             this.$element = t,
                 this.enabled = !0,
                 t.bind(s, {
                     target: this
                 }, this.__touchStart),
                 t[0].swipe = this,
                 this.onSwipe = null,
                 this.swipeType = "horizontal",
                 this.lastStatus = {}
         }
             ,
             (i = averta.TouchSwipe.prototype).getDirection = function(t, i) {
                 switch (this.swipeType) {
                     case "horizontal":
                         return t <= this.start_x ? "left" : "right";
                     case "vertical":
                         return i <= this.start_y ? "up" : "down";
                     case "all":
                         return Math.abs(t - this.start_x) > Math.abs(i - this.start_y) ? t <= this.start_x ? "left" : "right" : i <= this.start_y ? "up" : "down"
                 }
             }
             ,
             i.priventDefultEvent = function(t, i) {
                 var e = Math.abs(t - this.start_x) > Math.abs(i - this.start_y);
                 return "horizontal" === this.swipeType && e || "vertical" === this.swipeType && !e
             }
             ,
             i.createStatusObject = function(t) {
                 var i, e, s = {};
                 return i = this.lastStatus.distanceX || 0,
                     e = this.lastStatus.distanceY || 0,
                     s.distanceX = t.pageX - this.start_x,
                     s.distanceY = t.pageY - this.start_y,
                     s.moveX = s.distanceX - i,
                     s.moveY = s.distanceY - e,
                     s.distance = parseInt(Math.sqrt(Math.pow(s.distanceX, 2) + Math.pow(s.distanceY, 2))),
                     s.duration = (new Date).getTime() - this.start_time,
                     s.direction = this.getDirection(t.pageX, t.pageY),
                     s
             }
             ,
             i.__reset = function(t, i) {
                 this.reset = !1,
                     this.lastStatus = {},
                     this.start_time = (new Date).getTime(),
                     this.start_x = e ? t.touches[0].pageX : i.pageX,
                     this.start_y = e ? t.touches[0].pageY : i.pageY
             }
             ,
             i.__touchStart = function(i) {
                 var s, h, r = i.data.target, l = i;
                 if (r.enabled) {
                     if (i = i.originalEvent,
                         !r.onSwipe)
                         return void t.error("Swipe listener is undefined");
                     r.touchStarted || (r.start_x = e ? i.touches[0].pageX : l.pageX,
                         r.start_y = e ? i.touches[0].pageY : l.pageY,
                         r.start_time = (new Date).getTime(),
                         t(document).bind(o, {
                             target: r
                         }, r.__touchEnd).bind(n, {
                             target: r
                         }, r.__touchMove).bind(a, {
                             target: r
                         }, r.__touchCancel),
                         s = e ? i.touches[0] : l,
                         (h = r.createStatusObject(s)).phase = "start",
                         r.onSwipe.call(null, h),
                     e || l.preventDefault(),
                         r.lastStatus = h,
                         r.touchStarted = !0)
                 }
             }
             ,
             i.__touchMove = function(t) {
                 var i, s, n = t.data.target, o = t;
                 t = t.originalEvent,
                 n.touchStarted && (clearTimeout(n.timo),
                     n.timo = setTimeout((function() {
                             n.__reset(t, o)
                         }
                     ), 60),
                     i = e ? t.touches[0] : o,
                     s = n.createStatusObject(i),
                 n.priventDefultEvent(i.pageX, i.pageY) && o.preventDefault(),
                     s.phase = "move",
                     n.lastStatus = s,
                     n.onSwipe.call(null, s))
             }
             ,
             i.__touchEnd = function(i) {
                 var s, h = i.data.target, r = i;
                 i = i.originalEvent,
                     clearTimeout(h.timo),
                 e && i.touches[0],
                     s = h.lastStatus,
                 e || r.preventDefault(),
                     s.phase = "end",
                     h.touchStarted = !1,
                     h.priventEvt = null,
                     t(document).unbind(o, h.__touchEnd).unbind(n, h.__touchMove).unbind(a, h.__touchCancel),
                     s.speed = s.distance / s.duration,
                     h.onSwipe.call(null, s)
             }
             ,
             i.__touchCancel = function(t) {
                 t.data.target.__touchEnd(t)
             }
             ,
             i.enable = function() {
                 this.enabled || (this.enabled = !0)
             }
             ,
             i.disable = function() {
                 this.enabled && (this.enabled = !1)
             }
     }(jQuery),
     function() {
         "use strict";
         var t;
         averta.Ticker = function() {}
         ;
         var i = averta.Ticker
             , e = []
             , s = !0;
         i.add = function(t, s) {
             return e.push([t, s]),
             1 === e.length && i.start(),
                 e.length
         }
             ,
             i.remove = function(t, i) {
                 for (var s = 0, n = e.length; s < n; ++s)
                     e[s] && e[s][0] === t && e[s][1] === i && e.splice(s, 1)
             }
             ,
             i.start = function() {
                 s && (s = !1,
                     t())
             }
             ,
             i.stop = function() {
                 s = !0
             }
             ,
             t = function() {
                 if (!i.__stopped) {
                     for (var s = 0; s < e.length; ++s)
                         e[s][0].call(e[s][1]);
                     requestAnimationFrame(t)
                 }
             }
     }(),
     function() {
         "use strict";
         Date.now || (Date.now = function() {
                 return (new Date).getTime()
             }
         ),
             averta.Timer = function(t, i) {
                 this.delay = t,
                     this.currentCount = 0,
                     this.paused = !1,
                     this.onTimer = null,
                     this.refrence = null,
                 i && this.start()
             }
             ,
             averta.Timer.prototype = {
                 constructor: averta.Timer,
                 start: function() {
                     this.paused = !1,
                         this.lastTime = Date.now(),
                         averta.Ticker.add(this.update, this)
                 },
                 stop: function() {
                     this.paused = !0,
                         averta.Ticker.remove(this.update, this)
                 },
                 reset: function() {
                     this.currentCount = 0,
                         this.paused = !0,
                         this.lastTime = Date.now()
                 },
                 update: function() {
                     this.paused || Date.now() - this.lastTime < this.delay || (this.currentCount++,
                         this.lastTime = Date.now(),
                     this.onTimer && this.onTimer.call(this.refrence, this.getTime()))
                 },
                 getTime: function() {
                     return this.delay * this.currentCount
                 }
             }
     }(),
     function() {
         "use strict";
         var t, i = null;
         window.CSSTween = function(t, e, s, n) {
             this.$element = t,
                 this.duration = e || 1e3,
                 this.delay = s || 0,
                 this.ease = n || "linear",
             i || (i = "O" === window._jcsspfx ? "otransitionend" : "Webkit" == window._jcsspfx ? "webkitTransitionEnd" : "transitionend")
         }
             ,
             (t = CSSTween.prototype).to = function(t, i) {
                 return this.to_cb = t,
                     this.to_cb_target = i,
                     this
             }
             ,
             t.from = function(t, i) {
                 return this.fr_cb = t,
                     this.fr_cb_target = i,
                     this
             }
             ,
             t.onComplete = function(t, i) {
                 return this.oc_fb = t,
                     this.oc_fb_target = i,
                     this
             }
             ,
             t.chain = function(t) {
                 return this.chained_tween = t,
                     this
             }
             ,
             t.reset = function() {
                 clearTimeout(this.start_to),
                     clearTimeout(this.end_to)
             }
             ,
             t.start = function() {
                 clearTimeout(this.start_to),
                     clearTimeout(this.end_to),
                     this.fresh = !0,
                 this.fr_cb && (this.$element.css(window._jcsspfx + "TransitionDuration", "0ms"),
                     this.fr_cb.call(this.fr_cb_target));
                 var t = this;
                 return this.onTransComplete = function() {
                     t.fresh && (t.reset(),
                         this.$element.css(window._jcsspfx + "TransitionDuration", "").css(window._jcsspfx + "TransitionProperty", "").css(window._jcsspfx + "TransitionTimingFunction", "").css(window._jcsspfx + "TransitionDelay", ""),
                         t.fresh = !1,
                     t.chained_tween && t.chained_tween.start(),
                     t.oc_fb && t.oc_fb.call(t.oc_fb_target))
                 }
                     ,
                     this.start_to = setTimeout((function() {
                             t.$element.css(window._jcsspfx + "TransitionDuration", t.duration + "ms").css(window._jcsspfx + "TransitionProperty", "all"),
                                 t.delay > 0 ? t.$element.css(window._jcsspfx + "TransitionDelay", t.delay + "ms") : t.$element.css(window._jcsspfx + "TransitionDelay", ""),
                             "linear" != t.ease && t.$element.css(window._jcsspfx + "TransitionTimingFunction", t.ease),
                             t.to_cb && t.to_cb.call(t.to_cb_target),
                                 t.end_to = setTimeout((function() {
                                         t.onTransComplete()
                                     }
                                 ), t.duration + (t.delay || 0))
                         }
                     ), 100),
                     this
             }
     }(),
     function() {
         "use strict";
         function t(t, e) {
             var s;
             return (void 0 !== e.x || void 0 !== e.y) && (i ? (s = window._jcsspfx + "Transform",
             void 0 !== e.x && (e[s] = (e[s] || "") + " translateX(" + e.x + "px)",
                 delete e.x),
             void 0 !== e.y && (e[s] = (e[s] || "") + " translateY(" + e.y + "px)",
                 delete e.y)) : (void 0 !== e.x && (e["auto" !== t.css("right") ? "right" : "left"] = e.x + "px",
                 delete e.x),
             void 0 !== e.y && (e["auto" !== t.css("bottom") ? "bottom" : "top"] = e.y + "px",
                 delete e.y))),
                 e
         }
         var i = null;
         window.CTween = {},
             CTween.setPos = function(i, e) {
                 i.css(t(i, e))
             }
             ,
             CTween.animate = function(e, s, n, o) {
                 var a, h;
                 return null == i && (i = window._cssanim),
                     o = o || {},
                     t(e, n),
                     i ? ((a = new CSSTween(e,s,o.delay,EaseDic[o.ease])).to((function() {
                             e.css(n)
                         }
                     )),
                     o.complete && a.onComplete(o.complete, o.target),
                         a.start(),
                         a.stop = a.reset,
                         a) : (o.delay && e.delay(o.delay),
                     o.complete && (h = function() {
                             o.complete.call(o.target)
                         }
                     ),
                         e.stop(!0).animate(n, s, o.ease || "linear", h),
                         e)
             }
             ,
             CTween.fadeOut = function(t, i, e) {
                 var s = {};
                 e && (s.complete = function() {
                         t.remove()
                     }
                 ),
                     CTween.animate(t, i || 1e3, {
                         opacity: 0
                     }, s)
             }
             ,
             CTween.fadeIn = function(t, i) {
                 t.css("opacity", 0),
                     CTween.animate(t, i || 1e3, {
                         opacity: 1
                     })
             }
     }(),
     window.EaseDic = {
         linear: "linear",
         ease: "ease",
         easeIn: "ease-in",
         easeOut: "ease-out",
         easeInOut: "ease-in-out",
         easeInCubic: "cubic-bezier(.55,.055,.675,.19)",
         easeOutCubic: "cubic-bezier(.215,.61,.355,1)",
         easeInOutCubic: "cubic-bezier(.645,.045,.355,1)",
         easeInCirc: "cubic-bezier(.6,.04,.98,.335)",
         easeOutCirc: "cubic-bezier(.075,.82,.165,1)",
         easeInOutCirc: "cubic-bezier(.785,.135,.15,.86)",
         easeInExpo: "cubic-bezier(.95,.05,.795,.035)",
         easeOutExpo: "cubic-bezier(.19,1,.22,1)",
         easeInOutExpo: "cubic-bezier(1,0,0,1)",
         easeInQuad: "cubic-bezier(.55,.085,.68,.53)",
         easeOutQuad: "cubic-bezier(.25,.46,.45,.94)",
         easeInOutQuad: "cubic-bezier(.455,.03,.515,.955)",
         easeInQuart: "cubic-bezier(.895,.03,.685,.22)",
         easeOutQuart: "cubic-bezier(.165,.84,.44,1)",
         easeInOutQuart: "cubic-bezier(.77,0,.175,1)",
         easeInQuint: "cubic-bezier(.755,.05,.855,.06)",
         easeOutQuint: "cubic-bezier(.23,1,.32,1)",
         easeInOutQuint: "cubic-bezier(.86,0,.07,1)",
         easeInSine: "cubic-bezier(.47,0,.745,.715)",
         easeOutSine: "cubic-bezier(.39,.575,.565,1)",
         easeInOutSine: "cubic-bezier(.445,.05,.55,.95)",
         easeInBack: "cubic-bezier(.6,-.28,.735,.045)",
         easeOutBack: "cubic-bezier(.175, .885,.32,1.275)",
         easeInOutBack: "cubic-bezier(.68,-.55,.265,1.55)"
     },
     function() {
         "use strict";
         window.MSAligner = function(t, i, e) {
             this.$container = i,
                 this.$img = e,
                 this.type = t || "stretch",
                 this.widthOnly = !1,
                 this.heightOnly = !1
         }
         ;
         var t = MSAligner.prototype;
         t.init = function(t, i) {
             switch (this.baseWidth = t,
                 this.baseHeight = i,
                 this.imgRatio = t / i,
                 this.imgRatio2 = i / t,
                 this.type) {
                 case "tile":
                     this.$container.css("background-image", "url(" + this.$img.attr("src") + ")"),
                         this.$img.remove();
                     break;
                 case "center":
                     this.$container.css("background-image", "url(" + this.$img.attr("src") + ")"),
                         this.$container.css({
                             backgroundPosition: "center center",
                             backgroundRepeat: "no-repeat"
                         }),
                         this.$img.remove();
                     break;
                 case "stretch":
                     this.$img.css({
                         width: "100%",
                         height: "100%"
                     });
                     break;
                 case "fill":
                 case "fit":
                     this.needAlign = !0,
                         this.align()
             }
         }
             ,
             t.align = function() {
                 if (this.needAlign) {
                     var t = this.$container.width()
                         , i = this.$container.height()
                         , e = t / i;
                     "fill" == this.type ? this.imgRatio < e ? (this.$img.width(t),
                         this.$img.height(t * this.imgRatio2)) : (this.$img.height(i),
                         this.$img.width(i * this.imgRatio)) : "fit" == this.type && (this.imgRatio < e ? (this.$img.height(i),
                         this.$img.width(i * this.imgRatio)) : (this.$img.width(t),
                         this.$img.height(t * this.imgRatio2))),
                         this.setMargin()
                 }
             }
             ,
             t.setMargin = function() {
                 var t = this.$container.width()
                     , i = this.$container.height();
                 this.$img.css("margin-top", (i - this.$img[0].offsetHeight) / 2 + "px"),
                     this.$img.css("margin-left", (t - this.$img[0].offsetWidth) / 2 + "px")
             }
     }(),
     function() {
         "use strict";
         var t = {
             bouncing: !0,
             snapping: !1,
             snapsize: null,
             friction: .05,
             outFriction: .05,
             outAcceleration: .09,
             minValidDist: .3,
             snappingMinSpeed: 2,
             paging: !1,
             endless: !1,
             maxSpeed: 160
         }
             , i = function(i, e, s) {
             if (null === e || null === i)
                 throw new Error("Max and Min values are required.");
             for (var n in this.options = s || {},
                 t)
                 n in this.options || (this.options[n] = t[n]);
             this._max_value = e,
                 this._min_value = i,
                 this.value = i,
                 this.end_loc = i,
                 this.current_snap = this.getSnapNum(i),
                 this.__extrStep = 0,
                 this.__extraMove = 0,
                 this.__animID = -1
         }
             , e = i.prototype;
         e.changeTo = function(t, i, e, s, n) {
             if (this.stopped = !1,
                 this._internalStop(),
                 t = this._checkLimits(t),
                 e = Math.abs(e || 0),
             this.options.snapping && (s = s || this.getSnapNum(t),
             !1 !== n && this._callsnapChange(s),
                 this.current_snap = s),
                 i) {
                 this.animating = !0;
                 var o, a = this, h = ++a.__animID, r = t - a.value, l = 0, d = t, c = 1 - a.options.friction, p = function() {
                     if (h === a.__animID) {
                         var i = t - a.value;
                         if (!(Math.abs(i) > a.options.minValidDist && a.animating))
                             return a.animating && (a.value = t,
                                 a._callrenderer()),
                                 a.animating = !1,
                             h !== a.__animID && (a.__animID = -1),
                                 void a._callonComplete("anim");
                         window.requestAnimationFrame(p),
                             o = c + (e - 20) * c * 1.3 / a.options.maxSpeed,
                             a.value = d - r * Math.exp(-++l * o),
                             a._callrenderer()
                     }
                 };
                 p()
             } else
                 this.value = t,
                     this._callrenderer()
         }
             ,
             e.drag = function(t) {
                 this.start_drag && (this.drag_start_loc = this.value,
                     this.start_drag = !1),
                     this.animating = !1,
                     this._deceleration = !1,
                     this.value -= t,
                     !this.options.endless && (this.value > this._max_value || this.value < 0) ? this.options.bouncing ? (this.__isout = !0,
                         this.value += .6 * t) : this.value = this.value > this._max_value ? this._max_value : 0 : !this.options.endless && this.options.bouncing && (this.__isout = !1),
                     this._callrenderer()
             }
             ,
             e.push = function(t) {
                 if (this.stopped = !1,
                 this.options.snapping && Math.abs(t) <= this.options.snappingMinSpeed)
                     this.cancel();
                 else {
                     if (this.__speed = t,
                         this.__startSpeed = t,
                         this.end_loc = this._calculateEnd(),
                         this.options.snapping) {
                         var i = this.getSnapNum(this.value)
                             , e = this.getSnapNum(this.end_loc);
                         if (this.options.paging)
                             return i = this.getSnapNum(this.drag_start_loc),
                                 this.__isout = !1,
                                 void (t > 0 ? this.gotoSnap(i + 1, !0, t) : this.gotoSnap(i - 1, !0, t));
                         if (i === e)
                             return void this.cancel();
                         this._callsnapChange(e),
                             this.current_snap = e
                     }
                     this.animating = !1,
                         this.__needsSnap = this.options.endless || this.end_loc > this._min_value && this.end_loc < this._max_value,
                     this.options.snapping && this.__needsSnap && (this.__extraMove = this._calculateExtraMove(this.end_loc)),
                         this._startDecelaration()
                 }
             }
             ,
             e.bounce = function(t) {
                 this.animating || (this.stopped = !1,
                     this.animating = !1,
                     this.__speed = t,
                     this.__startSpeed = t,
                     this.end_loc = this._calculateEnd(),
                     this._startDecelaration())
             }
             ,
             e.stop = function() {
                 this.stopped = !0,
                     this._internalStop()
             }
             ,
             e.cancel = function() {
                 this.start_drag = !0,
                     this.__isout ? (this.__speed = 4e-4,
                         this._startDecelaration()) : this.options.snapping && this.gotoSnap(this.getSnapNum(this.value), !0)
             }
             ,
             e.renderCallback = function(t, i) {
                 this.__renderHook = {
                     fun: t,
                     ref: i
                 }
             }
             ,
             e.snappingCallback = function(t, i) {
                 this.__snapHook = {
                     fun: t,
                     ref: i
                 }
             }
             ,
             e.snapCompleteCallback = function(t, i) {
                 this.__compHook = {
                     fun: t,
                     ref: i
                 }
             }
             ,
             e.getSnapNum = function(t) {
                 return Math.floor((t + this.options.snapsize / 2) / this.options.snapsize)
             }
             ,
             e.nextSnap = function() {
                 this._internalStop();
                 var t = this.getSnapNum(this.value);
                 !this.options.endless && (t + 1) * this.options.snapsize > this._max_value ? (this.__speed = 8,
                     this.__needsSnap = !1,
                     this._startDecelaration()) : this.gotoSnap(t + 1, !0)
             }
             ,
             e.prevSnap = function() {
                 this._internalStop();
                 var t = this.getSnapNum(this.value);
                 !this.options.endless && (t - 1) * this.options.snapsize < this._min_value ? (this.__speed = -8,
                     this.__needsSnap = !1,
                     this._startDecelaration()) : this.gotoSnap(t - 1, !0)
             }
             ,
             e.gotoSnap = function(t, i, e) {
                 this.changeTo(t * this.options.snapsize, i, e, t)
             }
             ,
             e.destroy = function() {
                 this._internalStop(),
                     this.__renderHook = null,
                     this.__snapHook = null,
                     this.__compHook = null
             }
             ,
             e._internalStop = function() {
                 this.start_drag = !0,
                     this.animating = !1,
                     this._deceleration = !1,
                     this.__extrStep = 0
             }
             ,
             e._calculateExtraMove = function(t) {
                 var i = t % this.options.snapsize;
                 return i < this.options.snapsize / 2 ? -i : this.options.snapsize - i
             }
             ,
             e._calculateEnd = function(t) {
                 for (var i = this.__speed, e = this.value, s = 0; Math.abs(i) > this.options.minValidDist; )
                     e += i,
                         i *= this.options.friction,
                         s++;
                 return t ? s : e
             }
             ,
             e._checkLimits = function(t) {
                 return this.options.endless ? t : t < this._min_value ? this._min_value : t > this._max_value ? this._max_value : t
             }
             ,
             e._callrenderer = function() {
                 this.__renderHook && this.__renderHook.fun.call(this.__renderHook.ref, this, this.value)
             }
             ,
             e._callsnapChange = function(t) {
                 this.__snapHook && t !== this.current_snap && this.__snapHook.fun.call(this.__snapHook.ref, this, t, t - this.current_snap)
             }
             ,
             e._callonComplete = function(t) {
                 this.__compHook && !this.stopped && this.__compHook.fun.call(this.__compHook.ref, this, this.current_snap, t)
             }
             ,
             e._computeDeceleration = function() {
                 var t, i;
                 this.options.snapping && this.__needsSnap ? (t = (this.__startSpeed - this.__speed) / this.__startSpeed * this.__extraMove,
                     this.value += this.__speed + t - this.__extrStep,
                     this.__extrStep = t) : this.value += this.__speed,
                     this.__speed *= this.options.friction,
                 this.options.endless || this.options.bouncing || (this.value <= this._min_value ? (this.value = this._min_value,
                     this.__speed = 0) : this.value >= this._max_value && (this.value = this._max_value,
                     this.__speed = 0)),
                     this._callrenderer(),
                 !this.options.endless && this.options.bouncing && (i = 0,
                     this.value < this._min_value ? i = this._min_value - this.value : this.value > this._max_value && (i = this._max_value - this.value),
                     this.__isout = Math.abs(i) >= this.options.minValidDist,
                 this.__isout && (this.__speed * i <= 0 ? this.__speed += i * this.options.outFriction : this.__speed = i * this.options.outAcceleration))
             }
             ,
             e._startDecelaration = function() {
                 if (!this._deceleration) {
                     this._deceleration = !0;
                     var t = this
                         , i = function() {
                         t._deceleration && (t._computeDeceleration(),
                             Math.abs(t.__speed) > t.options.minValidDist || t.__isout ? window.requestAnimationFrame(i) : (t._deceleration = !1,
                                 t.__isout = !1,
                                 t.value = this.__needsSnap && t.options.snapping && !t.options.paging ? t._checkLimits(t.end_loc + t.__extraMove) : Math.round(t.value),
                                 t._callrenderer(),
                                 t._callonComplete("decel")))
                     };
                     i()
                 }
             }
             ,
             window.Controller = i
     }(),
     function(t) {
         window.MSLayerEffects = {};
         var i, e = {
             opacity: 0
         };
         MSLayerEffects.setup = function() {
             if (!i) {
                 i = !0;
                 var s = MSLayerEffects
                     , n = window._jcsspfx + "Transform"
                     , o = window._jcsspfx + "TransformOrigin"
                     , a = t.browser.opera;
                 _2d = window._css2d && window._cssanim && !a,
                     s.defaultValues = {
                         left: 0,
                         top: 0,
                         opacity: 1,
                         right: 0,
                         bottom: 0
                     },
                     s.defaultValues[n] = "",
                     s.rf = 1,
                     s.presetEffParams = {
                         random: "30|300",
                         long: 300,
                         short: 30,
                         false: !1,
                         true: !0,
                         tl: "top left",
                         bl: "bottom left",
                         tr: "top right",
                         br: "bottom right",
                         rt: "top right",
                         lb: "bottom left",
                         lt: "top left",
                         rb: "bottom right",
                         t: "top",
                         b: "bottom",
                         r: "right",
                         l: "left",
                         c: "center"
                     },
                     s.fade = function() {
                         return e
                     }
                     ,
                     s.left = _2d ? function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e[n] = "translateX(" + -t * s.rf + "px)",
                                 e
                         }
                         : function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e.left = -t * s.rf + "px",
                                 e
                         }
                     ,
                     s.right = _2d ? function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e[n] = "translateX(" + t * s.rf + "px)",
                                 e
                         }
                         : function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e.left = t * s.rf + "px",
                                 e
                         }
                     ,
                     s.top = _2d ? function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e[n] = "translateY(" + -t * s.rf + "px)",
                                 e
                         }
                         : function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e.top = -t * s.rf + "px",
                                 e
                         }
                     ,
                     s.bottom = _2d ? function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e[n] = "translateY(" + t * s.rf + "px)",
                                 e
                         }
                         : function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e.top = t * s.rf + "px",
                                 e
                         }
                     ,
                     s.from = _2d ? function(t, i, e) {
                             var o = !1 === e ? {} : {
                                 opacity: 0
                             };
                             return o[n] = "translateX(" + t * s.rf + "px) translateY(" + i * s.rf + "px)",
                                 o
                         }
                         : function(t, i, e) {
                             var n = !1 === e ? {} : {
                                 opacity: 0
                             };
                             return n.top = i * s.rf + "px",
                                 n.left = t * s.rf + "px",
                                 n
                         }
                     ,
                     s.rotate = _2d ? function(t, i) {
                             var e = {
                                 opacity: 0
                             };
                             return e[n] = " rotate(" + t + "deg)",
                             i && (e[o] = i),
                                 e
                         }
                         : function() {
                             return e
                         }
                     ,
                     s.rotateleft = _2d ? function(t, i, e, a) {
                             var h = s.left(i, a);
                             return h[n] += " rotate(" + t + "deg)",
                             e && (h[o] = e),
                                 h
                         }
                         : function(t, i, e, n) {
                             return s.left(i, n)
                         }
                     ,
                     s.rotateright = _2d ? function(t, i, e, a) {
                             var h = s.right(i, a);
                             return h[n] += " rotate(" + t + "deg)",
                             e && (h[o] = e),
                                 h
                         }
                         : function(t, i, e, n) {
                             return s.right(i, n)
                         }
                     ,
                     s.rotatetop = _2d ? function(t, i, e, a) {
                             var h = s.top(i, a);
                             return h[n] += " rotate(" + t + "deg)",
                             e && (h[o] = e),
                                 h
                         }
                         : function(t, i, e, n) {
                             return s.top(i, n)
                         }
                     ,
                     s.rotatebottom = _2d ? function(t, i, e, a) {
                             var h = s.bottom(i, a);
                             return h[n] += " rotate(" + t + "deg)",
                             e && (h[o] = e),
                                 h
                         }
                         : function(t, i, e, n) {
                             return s.bottom(i, n)
                         }
                     ,
                     s.rotatefrom = _2d ? function(t, i, e, a, h) {
                             var r = s.from(i, e, h);
                             return r[n] += " rotate(" + t + "deg)",
                             a && (r[o] = a),
                                 r
                         }
                         : function(t, i, e, n, o) {
                             return s.from(i, e, o)
                         }
                     ,
                     s.skewleft = _2d ? function(t, i, e) {
                             var o = s.left(i, e);
                             return o[n] += " skewX(" + t + "deg)",
                                 o
                         }
                         : function(t, i, e) {
                             return s.left(i, e)
                         }
                     ,
                     s.skewright = _2d ? function(t, i, e) {
                             var o = s.right(i, e);
                             return o[n] += " skewX(" + -t + "deg)",
                                 o
                         }
                         : function(t, i, e) {
                             return s.right(i, e)
                         }
                     ,
                     s.skewtop = _2d ? function(t, i, e) {
                             var o = s.top(i, e);
                             return o[n] += " skewY(" + t + "deg)",
                                 o
                         }
                         : function(t, i, e) {
                             return s.top(i, e)
                         }
                     ,
                     s.skewbottom = _2d ? function(t, i, e) {
                             var o = s.bottom(i, e);
                             return o[n] += " skewY(" + -t + "deg)",
                                 o
                         }
                         : function(t, i, e) {
                             return s.bottom(i, e)
                         }
                     ,
                     s.scale = _2d ? function(t, i, e, s) {
                             var a = !1 === s ? {} : {
                                 opacity: 0
                             };
                             return a[n] = " scaleX(" + t + ") scaleY(" + i + ")",
                             e && (a[o] = e),
                                 a
                         }
                         : function(t, i, e, s) {
                             return !1 === s ? {} : {
                                 opacity: 0
                             }
                         }
                     ,
                     s.scaleleft = _2d ? function(t, i, e, a, h) {
                             var r = s.left(e, h);
                             return r[n] = " scaleX(" + t + ") scaleY(" + i + ")",
                             a && (r[o] = a),
                                 r
                         }
                         : function(t, i, e, n, o) {
                             return s.left(e, o)
                         }
                     ,
                     s.scaleright = _2d ? function(t, i, e, a, h) {
                             var r = s.right(e, h);
                             return r[n] = " scaleX(" + t + ") scaleY(" + i + ")",
                             a && (r[o] = a),
                                 r
                         }
                         : function(t, i, e, n, o) {
                             return s.right(e, o)
                         }
                     ,
                     s.scaletop = _2d ? function(t, i, e, a, h) {
                             var r = s.top(e, h);
                             return r[n] = " scaleX(" + t + ") scaleY(" + i + ")",
                             a && (r[o] = a),
                                 r
                         }
                         : function(t, i, e, n, o) {
                             return s.top(e, o)
                         }
                     ,
                     s.scalebottom = _2d ? function(t, i, e, a, h) {
                             var r = s.bottom(e, h);
                             return r[n] = " scaleX(" + t + ") scaleY(" + i + ")",
                             a && (r[o] = a),
                                 r
                         }
                         : function(t, i, e, n, o) {
                             return s.bottom(e, o)
                         }
                     ,
                     s.scalefrom = _2d ? function(t, i, e, a, h, r) {
                             var l = s.from(e, a, r);
                             return l[n] += " scaleX(" + t + ") scaleY(" + i + ")",
                             h && (l[o] = h),
                                 l
                         }
                         : function(t, i, e, n, o, a) {
                             return s.from(e, n, a)
                         }
                     ,
                     s.rotatescale = _2d ? function(t, i, e, a, h) {
                             var r = s.scale(i, e, a, h);
                             return r[n] += " rotate(" + t + "deg)",
                             a && (r[o] = a),
                                 r
                         }
                         : function(t, i, e, n, o) {
                             return s.scale(i, e, n, o)
                         }
                     ,
                     s.front = window._css3d ? function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e[n] = "perspective(2000px) translate3d(0 , 0 ," + t + "px ) rotate(0.001deg)",
                                 e
                         }
                         : function() {
                             return e
                         }
                     ,
                     s.back = window._css3d ? function(t, i) {
                             var e = !1 === i ? {} : {
                                 opacity: 0
                             };
                             return e[n] = "perspective(2000px) translate3d(0 , 0 ," + -t + "px ) rotate(0.001deg)",
                                 e
                         }
                         : function() {
                             return e
                         }
                     ,
                     s.rotatefront = window._css3d ? function(t, i, e, s) {
                             var a = !1 === s ? {} : {
                                 opacity: 0
                             };
                             return a[n] = "perspective(2000px) translate3d(0 , 0 ," + i + "px ) rotate(" + (t || .001) + "deg)",
                             e && (a[o] = e),
                                 a
                         }
                         : function() {
                             return e
                         }
                     ,
                     s.rotateback = window._css3d ? function(t, i, e, s) {
                             var a = !1 === s ? {} : {
                                 opacity: 0
                             };
                             return a[n] = "perspective(2000px) translate3d(0 , 0 ," + -i + "px ) rotate(" + (t || .001) + "deg)",
                             e && (a[o] = e),
                                 a
                         }
                         : function() {
                             return e
                         }
                     ,
                     s.rotate3dleft = window._css3d ? function(t, i, e, a, h, r) {
                             var l = s.left(a, r);
                             return l[n] += (t ? " rotateX(" + t + "deg)" : " ") + (i ? " rotateY(" + i + "deg)" : "") + (e ? " rotateZ(" + e + "deg)" : ""),
                             h && (l[o] = h),
                                 l
                         }
                         : function(t, i, e, n, o, a) {
                             return s.left(n, a)
                         }
                     ,
                     s.rotate3dright = window._css3d ? function(t, i, e, a, h, r) {
                             var l = s.right(a, r);
                             return l[n] += (t ? " rotateX(" + t + "deg)" : " ") + (i ? " rotateY(" + i + "deg)" : "") + (e ? " rotateZ(" + e + "deg)" : ""),
                             h && (l[o] = h),
                                 l
                         }
                         : function(t, i, e, n, o, a) {
                             return s.right(n, a)
                         }
                     ,
                     s.rotate3dtop = window._css3d ? function(t, i, e, a, h, r) {
                             var l = s.top(a, r);
                             return l[n] += (t ? " rotateX(" + t + "deg)" : " ") + (i ? " rotateY(" + i + "deg)" : "") + (e ? " rotateZ(" + e + "deg)" : ""),
                             h && (l[o] = h),
                                 l
                         }
                         : function(t, i, e, n, o, a) {
                             return s.top(n, a)
                         }
                     ,
                     s.rotate3dbottom = window._css3d ? function(t, i, e, a, h, r) {
                             var l = s.bottom(a, r);
                             return l[n] += (t ? " rotateX(" + t + "deg)" : " ") + (i ? " rotateY(" + i + "deg)" : "") + (e ? " rotateZ(" + e + "deg)" : ""),
                             h && (l[o] = h),
                                 l
                         }
                         : function(t, i, e, n, o, a) {
                             return s.bottom(n, a)
                         }
                     ,
                     s.rotate3dfront = window._css3d ? function(t, i, e, a, h, r) {
                             var l = s.front(a, r);
                             return l[n] += (t ? " rotateX(" + t + "deg)" : " ") + (i ? " rotateY(" + i + "deg)" : "") + (e ? " rotateZ(" + e + "deg)" : ""),
                             h && (l[o] = h),
                                 l
                         }
                         : function(t, i, e, n, o, a) {
                             return s.front(n, a)
                         }
                     ,
                     s.rotate3dback = window._css3d ? function(t, i, e, a, h, r) {
                             var l = s.back(a, r);
                             return l[n] += (t ? " rotateX(" + t + "deg)" : " ") + (i ? " rotateY(" + i + "deg)" : "") + (e ? " rotateZ(" + e + "deg)" : ""),
                             h && (l[o] = h),
                                 l
                         }
                         : function(t, i, e, n, o, a) {
                             return s.back(n, a)
                         }
                     ,
                     s.t = window._css3d ? function(t, i, e, a, h, r, l, d, c, p, u, m, f, _, v) {
                             var w, g = !1 === t ? {} : {
                                 opacity: 0
                             }, S = "";
                             return "n" !== i && (S += "translateX(" + i * s.rf + "px) "),
                             "n" !== e && (S += "translateY(" + e * s.rf + "px) "),
                             "n" !== a && (S += "translateZ(" + a * s.rf + "px) "),
                             "n" !== h && (S += "rotate(" + h + "deg) "),
                             "n" !== r && (S += "rotateX(" + r + "deg) "),
                             "n" !== l && (S += "rotateY(" + l + "deg) "),
                             "n" !== d && (S += "rotateZ(" + d + "deg) "),
                             "n" !== u && (S += "skewX(" + u + "deg) "),
                             "n" !== m && (S += "skewY(" + m + "deg) "),
                             "n" !== c && (S += "scaleX(" + c + ") "),
                             "n" !== p && (S += "scaleY(" + p + ")"),
                                 g[n] = S,
                                 w = "",
                                 w += "n" !== f ? f + "% " : "50% ",
                                 w += "n" !== _ ? _ + "% " : "50% ",
                                 w += "n" !== v ? v + "px" : "",
                                 g[o] = w,
                                 g
                         }
                         : function(t, i, e, n, o) {
                             o = !1 === t ? {} : {
                                 opacity: 0
                             };
                             return "n" !== i && (o.left += i * s.rf + "px"),
                             "n" !== e && (o.top += e * s.rf + "px"),
                                 o
                         }
             }
         }
     }(jQuery),
     function(t) {
         window.MSLayerElement = function() {
             this.$cont = t("<div></div>").addClass("layer-cont"),
                 this.start_anim = {
                     name: "fade",
                     duration: 1e3,
                     ease: "linear",
                     delay: 0
                 },
                 this.end_anim = {
                     duration: 1e3,
                     ease: "linear"
                 },
                 this.type = "text",
                 this.swipe = !0,
                 this.resizable = !0,
                 this.minWidth = -1,
                 this.__cssConfig = ["margin-top", "padding-top", "margin-bottom", "padding-left", "margin-right", "padding-right", "margin-left", "padding-bottom", "left", "right", "top", "bottom", "font-size", "line-height", "width", "height"],
                 this.baseStyle = {}
         }
         ;
         var i = MSLayerElement.prototype;
         i.__playAnimation = function(t, i) {
             var e = {};
             t.ease && (e.ease = t.ease),
                 this.show_tween = CTween.animate(this.$element, t.duration, i, e)
         }
             ,
             i._randomParam = function(t) {
                 var i = Number(t.slice(0, t.indexOf("|")))
                     , e = Number(t.slice(t.indexOf("|") + 1));
                 return i + Math.random() * (e - i)
             }
             ,
             i._parseEff = function(t) {
                 var i, e, s, n, o = [];
                 if (-1 !== t.indexOf("("))
                     for (i = t.slice(0, t.indexOf("(")).toLowerCase(),
                              o = t.slice(t.indexOf("(") + 1, -1).replace(/\"|\'|\s/g, "").split(","),
                              t = i,
                              s = 0,
                              n = o.length; s < n; ++s)
                         (e = o[s])in MSLayerEffects.presetEffParams && (e = MSLayerEffects.presetEffParams[e]),
                             o[s] = e;
                 return {
                     eff_name: t,
                     eff_params: o
                 }
             }
             ,
             i._parseEffParams = function(t) {
                 for (var i, e = [], s = 0, n = t.length; s < n; ++s)
                     "string" == typeof (i = t[s]) && -1 !== i.indexOf("|") && (i = this._randomParam(i)),
                         e[s] = i;
                 return e
             }
             ,
             i._checkPosKey = function(t, i) {
                 return "left" === t && !(t in this.baseStyle) && "right"in this.baseStyle ? (i.right = -parseInt(i.left) + "px",
                     delete i.left,
                     !0) : "top" === t && !(t in this.baseStyle) && "bottom"in this.baseStyle && (i.bottom = -parseInt(i.top) + "px",
                     delete i.top,
                     !0)
             }
             ,
             i.setStartAnim = function(i) {
                 t.extend(this.start_anim, i),
                     t.extend(this.start_anim, this._parseEff(this.start_anim.name)),
                     this.$element.css("visibility", "hidden")
             }
             ,
             i.setEndAnim = function(i) {
                 t.extend(this.end_anim, i)
             }
             ,
             i.create = function() {
                 this.$element.css("display", "none"),
                     this.$element.removeAttr("data-delay").removeAttr("data-effect").removeAttr("data-duration").removeAttr("data-type"),
                 this.end_anim.name || (this.end_anim.name = this.start_anim.name),
                 this.end_anim.time && (this.autoHide = !0),
                     t.extend(this.end_anim, this._parseEff(this.end_anim.name))
             }
             ,
             i.init = function() {
                 var t, i, e, s;
                 for (this.initialized = !0,
                          this.$element.css("visibility", ""),
                          i = 0,
                          e = this.__cssConfig.length; i < e; i++)
                     s = this.__cssConfig[i],
                     "auto" != (t = "text" === this.type && "width" === s ? this.$element[0].style.width : this.$element.css(s)) && "" != t && "normal" != t && (this.baseStyle[s] = parseInt(t))
             }
             ,
             i.locate = function() {
                 var t, i = this.slide.$layers, e = parseFloat(i.css("width"));
                 if (this.visible(this.minWidth < e),
                     this.resizable)
                     for (t in this.factor = e / this.slide.slider.options.width,
                         this.baseStyle)
                         this.$element.css(t, this.baseStyle[t] * this.factor + "px")
             }
             ,
             i.start = function() {
                 var t, i, e, s, n;
                 if (!this.isShowing) {
                     for (t in this.isShowing = !0,
                         MSLayerEffects.rf = this.factor,
                         e = MSLayerEffects[this.start_anim.eff_name].apply(null, this._parseEffParams(this.start_anim.eff_params)),
                         s = {},
                         e)
                         this._checkPosKey(t, e) || (null != MSLayerEffects.defaultValues[t] && (s[t] = MSLayerEffects.defaultValues[t]),
                         t in this.baseStyle && (i = this.baseStyle[t],
                             e[t] = i + parseFloat(e[t]) + "px",
                             s[t] = i + "px"),
                             this.$element.css(t, e[t]));
                     n = this,
                         clearTimeout(this.to),
                         this.to = setTimeout((function() {
                                 n.$element.css("display", ""),
                                     n.__playAnimation(n.start_anim, s)
                             }
                         ), n.start_anim.delay || .01),
                         this.cl_to = setTimeout((function() {
                                 n.show_cl = !0
                             }
                         ), (this.start_anim.delay || .01) + this.start_anim.duration),
                     this.autoHide && (clearTimeout(this.hto),
                         this.hto = setTimeout((function() {
                                 n.hide()
                             }
                         ), n.end_anim.time))
                 }
             }
             ,
             i.hide = function() {
                 this.isShowing = !1;
                 var t = MSLayerEffects[this.end_anim.eff_name].apply(null, this._parseEffParams(this.end_anim.eff_params));
                 for (key in t)
                     this._checkPosKey(key, t) || (key === window._jcsspfx + "TransformOrigin" && this.$element.css(key, t[key]),
                     key in this.baseStyle && (t[key] = this.baseStyle[key] + parseFloat(t[key]) + "px"));
                 this.__playAnimation(this.end_anim, t),
                     clearTimeout(this.to),
                     clearTimeout(this.hto),
                     clearTimeout(this.cl_to)
             }
             ,
             i.reset = function() {
                 this.isShowing = !1,
                     this.$element[0].style.display = "none",
                     this.$element.css("opacity", "100"),
                     this.$element[0].style.transitionDuration = "0ms",
                 this.show_tween && this.show_tween.stop(!0),
                     clearTimeout(this.to),
                     clearTimeout(this.hto)
             }
             ,
             i.destroy = function() {
                 this.reset(),
                     this.$element.remove(),
                     this.$cont.remove()
             }
             ,
             i.visible = function(t) {
                 this.isVisible != t && (this.isVisible = t,
                     this.$element.css("display", t ? "" : "none"))
             }
     }(jQuery),
     function(t) {
         window.MSImageLayerElement = function() {
             MSLayerElement.call(this),
                 this.needPreload = !0,
                 this.__cssConfig = ["margin-top", "padding-top", "margin-bottom", "padding-left", "margin-right", "padding-right", "margin-left", "padding-bottom", "left", "right", "top", "bottom", "width", "height"]
         }
             ,
             MSImageLayerElement.extend(MSLayerElement);
         var i = MSImageLayerElement.prototype
             , e = MSLayerElement.prototype;
         i.create = function() {
             var i;
             this.link && (this.$element.parent().append(this.link),
                 this.link.append(this.$element),
                 this.link.removeClass("ms-layer"),
                 this.$element.addClass("ms-layer")),
                 e.create.call(this),
                 null != this.$element.data("src") ? (this.img_src = this.$element.data("src"),
                     this.$element.removeAttr("data-src")) : (i = this,
                     this.$element.on("load", (function() {
                             i.slide.preloadCount--,
                             0 === i.slide.preloadCount && i.slide.___onlayersReady()
                         }
                     )).each(t.jqLoadFix)),
             t.browser.msie && this.$element.on("dragstart", (function(t) {
                     t.preventDefault()
                 }
             ))
         }
             ,
             i.loadImage = function() {
                 var t = this;
                 this.$element.preloadImg(this.img_src, (function() {
                         t.slide.preloadCount--,
                         0 === t.slide.preloadCount && t.slide.___onlayersReady()
                     }
                 ))
             }
     }(jQuery),
     function(t) {
         window.MSVideoLayerElement = function() {
             MSLayerElement.call(this)
         }
             ,
             MSVideoLayerElement.extend(MSLayerElement);
         var i = MSVideoLayerElement.prototype
             , e = MSLayerElement.prototype;
         i.__playVideo = function() {
             this.img && CTween.fadeOut(this.img, 500, !1),
                 CTween.fadeOut(this.video_btn, 500, !1),
                 this.video_frame.attr("src", "about:blank").css("display", "block"),
             -1 == this.video_url.indexOf("?") && (this.video_url += "?"),
                 this.video_frame.attr("src", this.video_url + "&autoplay=1")
         }
             ,
             i.reset = function() {
                 e.reset.call(this),
                 (this.needPreload || this.$element.data("btn")) && (this.video_btn.css("opacity", 1),
                     this.video_frame.attr("src", "about:blank").css("display", "none")),
                     this.needPreload ? this.img.css("opacity", 1) : this.video_frame.attr("src", this.video_url)
             }
             ,
             i.create = function() {
                 var i, s;
                 e.create.call(this),
                     this.video_frame = this.$element.find("iframe").css({
                         width: "100%",
                         height: "100%"
                     }),
                     this.video_url = this.video_frame.attr("src"),
                 ((i = 0 != this.$element.has("img").length) || this.$element.data("btn")) && (this.video_frame.attr("src", "about:blank").css("display", "none"),
                     s = this,
                     this.video_btn = t("<div></div>").appendTo(this.$element).addClass("ms-video-btn").click((function() {
                             s.__playVideo()
                         }
                     )),
                     i) && (this.needPreload = !0,
                     this.img = this.$element.find("img:first").addClass("ms-video-img"),
                     void 0 !== this.img.data("src") ? (this.img_src = this.img.data("src"),
                         this.img.removeAttr("data-src")) : (s = this,
                         this.img.attr("src", this.img_src).on("load", (function() {
                                 s.slide.preloadCount--,
                                 0 == s.slide.preloadCount && s.slide.___onlayersReady()
                             }
                         )).each(t.jqLoadFix)),
                     t.browser.msie) && this.img.on("dragstart", (function(t) {
                         t.preventDefault()
                     }
                 ))
             }
             ,
             i.loadImage = function() {
                 var t = this;
                 this.img.preloadImg(this.img_src, (function() {
                         t.slide.preloadCount--,
                         0 == t.slide.preloadCount && t.slide.___onlayersReady()
                     }
                 ))
             }
     }(jQuery),
     function(t) {
         "use strict";
         window.MSHotspotLayer = function() {
             MSLayerElement.call(this),
                 this.__cssConfig = ["margin-top", "padding-top", "margin-bottom", "padding-left", "margin-right", "padding-right", "margin-left", "padding-bottom", "left", "right", "top", "bottom"],
                 this.ease = "Expo"
         }
             ,
             MSHotspotLayer.extend(MSLayerElement);
         var i = MSHotspotLayer.prototype
             , e = MSLayerElement.prototype;
         i._showTT = function() {
             this.show_cl && (this.align = this._orgAlign,
                 this._locateTT(),
                 this.hide_start = !1,
             this._tween && this._tween.stop(!0),
                 this.tt.css({
                     display: "block"
                 }),
                 this._tween = CTween.animate(this.tt, 900, this.to, {
                     ease: "easeOut" + this.ease
                 }))
         }
             ,
             i._hideTT = function() {
                 if (this.show_cl) {
                     this._tween && this._tween.stop(!0);
                     var t = this;
                     this._tween = CTween.animate(this.tt, 900, this.from, {
                         ease: "easeOut" + this.ease,
                         complete: function() {
                             t.tt.css("display", "none")
                         }
                     })
                 }
             }
             ,
             i._updateClassName = function(t) {
                 this._lastClass && this.tt.removeClass(this._lastClass),
                     this.tt.addClass(t),
                     this._lastClass = t
             }
             ,
             i._alignPolicy = function() {
                 this.tt.outerHeight();
                 var t = Math.max(this.tt.outerWidth(), parseInt(this.tt.css("max-width")))
                     , i = window.innerWidth;
                 window.innerHeight;
                 switch (this.align) {
                     case "top":
                         if (this.base_t < 0)
                             return "bottom";
                         break;
                     case "right":
                         if (this.base_l + t > i || this.base_t < 0)
                             return "bottom";
                         break;
                     case "left":
                         if (this.base_l < 0 || this.base_t < 0)
                             return "bottom"
                 }
                 return null
             }
             ,
             i._locateTT = function() {
                 var t, i, e, s = this.$element.offset(), n = this.slide.slider.$element.offset(), o = 50;
                 switch (this.pos_x = s.left - n.left - this.slide.slider.$element.scrollLeft(),
                     this.pos_y = s.top - n.top - this.slide.slider.$element.scrollTop(),
                     this.from = {
                         opacity: 0
                     },
                     this.to = {
                         opacity: 1
                     },
                     this._updateClassName("ms-tooltip-" + this.align),
                     this.tt_arrow.css("margin-left", ""),
                     t = 15,
                     15,
                     this.align) {
                     case "top":
                         i = Math.max(this.tt.outerWidth(), parseInt(this.tt.css("max-width"))),
                             this.base_t = this.pos_y - this.tt.outerHeight() - 15 - 15,
                             this.base_l = this.pos_x - i / 2,
                         this.base_l + i > window.innerWidth && (this.tt_arrow.css("margin-left", -7.5 + this.base_l + i - window.innerWidth + "px"),
                             this.base_l = window.innerWidth - i),
                         this.base_l < 0 && (this.base_l = 0,
                             this.tt_arrow.css("margin-left", -7.5 + this.pos_x - this.tt.outerWidth() / 2 + "px")),
                             window._css3d ? (this.from[window._jcsspfx + "Transform"] = "translateY(-50px)",
                                 this.to[window._jcsspfx + "Transform"] = "") : (this.from.top = this.base_t - o + "px",
                                 this.to.top = this.base_t + "px");
                         break;
                     case "bottom":
                         i = Math.max(this.tt.outerWidth(), parseInt(this.tt.css("max-width"))),
                             this.base_t = this.pos_y + 15 + 15,
                             this.base_l = this.pos_x - i / 2,
                         this.base_l + i > window.innerWidth && (this.tt_arrow.css("margin-left", -7.5 + this.base_l + i - window.innerWidth + "px"),
                             this.base_l = window.innerWidth - i),
                         this.base_l < 0 && (this.base_l = 0,
                             this.tt_arrow.css("margin-left", -7.5 + this.pos_x - this.tt.outerWidth() / 2 + "px")),
                             window._css3d ? (this.from[window._jcsspfx + "Transform"] = "translateY(50px)",
                                 this.to[window._jcsspfx + "Transform"] = "") : (this.from.top = this.base_t + o + "px",
                                 this.to.top = this.base_t + "px");
                         break;
                     case "right":
                         this.base_l = this.pos_x + t + 15,
                             this.base_t = this.pos_y - this.tt.outerHeight() / 2,
                             window._css3d ? (this.from[window._jcsspfx + "Transform"] = "translateX(50px)",
                                 this.to[window._jcsspfx + "Transform"] = "") : (this.from.left = this.base_l + o + "px",
                                 this.to.left = this.base_l + "px");
                         break;
                     case "left":
                         this.base_l = this.pos_x - t - this.tt.outerWidth() - 15,
                             this.base_t = this.pos_y - this.tt.outerHeight() / 2,
                             window._css3d ? (this.from[window._jcsspfx + "Transform"] = "translateX(-50px)",
                                 this.to[window._jcsspfx + "Transform"] = "") : (this.from.left = this.base_l - o + "px",
                                 this.to.left = this.base_l + "px")
                 }
                 if (null !== (e = this._alignPolicy()))
                     return this.align = e,
                         void this._locateTT();
                 this.tt.css("top", parseInt(this.base_t) + "px").css("left", parseInt(this.base_l) + "px"),
                     this.tt.css(this.from)
             }
             ,
             i.start = function() {
                 e.start.call(this),
                     this.tt.appendTo(this.slide.slider.$element),
                     this.tt.css("display", "none")
             }
             ,
             i.reset = function() {
                 e.reset.call(this),
                     this.tt.detach()
             }
             ,
             i.create = function() {
                 var i, s, n = this;
                 e.create.call(this),
                     this._orgAlign = this.align = void 0 !== this.$element.data("align") ? this.$element.data("align") : "top",
                     this.data = this.$element.html(),
                     this.$element.html("").on("mouseenter", (function() {
                             n._showTT()
                         }
                     )).on("mouseleave", (function() {
                             n._hideTT()
                         }
                     )),
                     this.point = t('<div><div class="ms-point-center"></div><div class="ms-point-border"></div></div>').addClass("ms-tooltip-point").appendTo(this.$element),
                     i = this.$element.data("link"),
                     s = this.$element.data("target"),
                 i && this.point.on("click", (function() {
                         window.open(i, s || "_self")
                     }
                 )),
                     this.tt = t("<div></div>").addClass("ms-tooltip").css("display", "hidden").css("opacity", 0),
                     this.tt_arrow = t("<div></div>").addClass("ms-tooltip-arrow").appendTo(this.tt),
                     this._updateClassName("ms-tooltip-" + this.align),
                     this.ttcont = t("<div></div>").addClass("ms-tooltip-cont").html(this.data).appendTo(this.tt)
             }
     }(jQuery),
     window.MSSliderEvent = function(t) {
         this.type = t
     }
     ,
     MSSliderEvent.CHANGE_START = "changeStart",
     MSSliderEvent.CHANGE_END = "changeEnd",
     MSSliderEvent.WATING = "wating",
     MSSliderEvent.AUTOPLAY_CHANGE = "autoplayChange",
     MSSliderEvent.VIDEO_PLAY = "videoPlay",
     MSSliderEvent.VIDEO_CLOSE = "videoClose",
     MSSliderEvent.INIT = "init",
     MSSliderEvent.RESIZE = "resize",
     MSSliderEvent.RESERVED_SPACE_CHANGE = "rsc",
     function(t) {
         "use strict";
         window.MSSlide = function() {
             this.$element = null,
                 this.$loading = t("<div></div>").addClass("ms-slide-loading"),
                 this.layers = [],
                 this.view = null,
                 this.index = -1,
                 this.__width = 0,
                 this.__height = 0,
                 this.preloadCount = 0,
                 this.fillMode = "fill",
                 this.selected = !1,
                 this.pselected = !1,
                 this.autoAppend = !0,
                 this.moz = t.browser.mozilla
         }
         ;
         var i = MSSlide.prototype;
         i.onSwipeStart = function() {
             this.link && (this.linkdis = !0),
             this.video && (this.videodis = !0)
         }
             ,
             i.onSwipeCancel = function() {
                 this.link && (this.linkdis = !1),
                 this.video && (this.videodis = !1)
             }
             ,
             i.addLayer = function(i) {
                 this.hasLayers || (this.$layers = t("<div></div>").addClass("ms-slide-layers")),
                     this.hasLayers = !0,
                     this.$layers.append(i.$element),
                     this.layers.push(i),
                     i.slide = this,
                     i.create(),
                 i.needPreload && this.preloadCount++
             }
             ,
             i.___onlayersReady = function() {
                 this.ready = !0,
                     this.slider.api._startTimer(),
                 this.selected && (this.showLayers(),
                 this.vinit && (this.bgvideo.play(),
                 this.autoPauseBgVid || (this.bgvideo.currentTime = 0))),
                 this.isSleeping || this.setup(),
                     CTween.fadeOut(this.$loading, 300, !0),
                     (0 === this.slider.options.preload || "all" === this.slider.options.preload) && this.index < this.view.slideList.length - 1 ? this.view.slideList[this.index + 1].loadImages() : "all" === this.slider.options.preload && this.index === this.view.slideList.length - 1 && this.slider._removeLoading()
             }
             ,
             i.startLayers = function() {
                 for (var t = 0, i = this.layers.length; t < i; ++t)
                     this.layers[t].start()
             }
             ,
             i.initLayers = function(t) {
                 if ((!this.init || t) && !this.slider.init_safemode) {
                     this.init = !0;
                     for (var i = 0, e = this.layers.length; i < e; ++i)
                         this.layers[i].init()
                 }
             }
             ,
             i.locateLayers = function() {
                 for (var t = 0, i = this.layers.length; t < i; ++t)
                     this.layers[t].locate()
             }
             ,
             i.resetLayers = function() {
                 this.$layers.css("display", "none"),
                     this.$layers.css("opacity", 1);
                 for (var t = 0, i = this.layers.length; t < i; ++t)
                     this.layers[t].reset()
             }
             ,
             i.hideLayers = function() {
                 if (0 === this.preloadCount)
                     for (var t = 0, i = this.layers.length; t < i; ++t)
                         this.layers[t].hide()
             }
             ,
             i.showLayers = function() {
                 this.hasLayers && (this.lht && (this.lht.reset ? this.lht.reset() : this.lht.stop("true")),
                     this.resetLayers(),
                     this.$layers.css("opacity", 1).css("display", ""),
                 0 === this.preloadCount && (this.initLayers(),
                     this.locateLayers(),
                     this.startLayers()))
             }
             ,
             i.setBG = function(i) {
                 this.hasBG = !0;
                 var e = this;
                           if(i === document.querySelector(".mobile-widget-wrapper .main-image .ms-slide img")) {
                     i.src = i.dataset.src;
                 }
           if (i === document.querySelector(".mainproductpagedesktop .main-image .ms-slide img")) {
                     i.src = i.dataset.src;
                 }
                 this.$imgcont = t("<div></div>").addClass("ms-slide-bgcont"),
                     this.$element.append(this.$loading).append(this.$imgcont),
                     this.$bg_img = t(i).css("visibility", "hidden"),
                     this.$imgcont.append(this.$bg_img),
                     this.bgAligner = new MSAligner(e.fillMode,e.$imgcont,e.$bg_img),
                     this.bgAligner.widthOnly = this.slider.options.autoHeight,
                 e.slider.options.autoHeight && (e.pselected || e.selected) && e.slider.setHeight(e.slider.options.height),
                     void 0 !== this.$bg_img.data("src") ? (this.bg_src = this.$bg_img.data("src"),
                         this.$bg_img.removeAttr("data-src")) : this.$bg_img.one("load", (function(t) {
                             e._onBGLoad(t)
                         }
                     )).each(t.jqLoadFix),
                     this.preloadCount++
             }
             ,
             i._onBGLoad = function(i) {
                 this.bgNatrualWidth = i.width,
                     this.bgNatrualHeight = i.height,
                     this.bgLoaded = !0,
                 t.browser.msie && this.$bg_img.on("dragstart", (function(t) {
                         t.preventDefault()
                     }
                 )),
                     this.preloadCount--,
                 0 === this.preloadCount && this.___onlayersReady()
             }
             ,
             i.loadImages = function() {
                 var t, i, e;
                 if (!this.ls) {
                     for (this.ls = !0,
                          this.hasBG && this.bg_src && (t = this,
                              this.$bg_img.preloadImg(this.bg_src, (function(i) {
                                      t._onBGLoad(i)
                                  }
                              ))),
                              i = 0,
                              e = this.layers.length; i < e; ++i)
                         this.layers[i].needPreload && this.layers[i].loadImage();
                     this.bgvideo && this.bgvideo.load()
                 }
             }
             ,
             i.setBGVideo = function(i) {
                 if (i[0].play) {
                     if (window._mobile)
                         return void i.remove();
                     this.bgvideo = i[0];
                     var e = this;
                     i.addClass("ms-slide-bgvideo"),
                     !1 !== i.data("loop") && this.bgvideo.addEventListener("ended", (function() {
                             e.bgvideo.play()
                         }
                     )),
                     !1 !== i.data("mute") && (this.bgvideo.muted = !0),
                     !0 === i.data("autopause") && (this.autoPauseBgVid = !0),
                         this.bgvideo_fillmode = i.data("fill-mode") || "fill",
                     "none" !== this.bgvideo_fillmode && (this.bgVideoAligner = new MSAligner(this.bgvideo_fillmode,this.$element,i),
                         this.bgvideo.addEventListener("loadedmetadata", (function() {
                                 e.vinit || (e.vinit = !0,
                                     e.video_aspect = e.bgVideoAligner.baseHeight / e.bgVideoAligner.baseWidth,
                                     e.bgVideoAligner.init(e.bgvideo.videoWidth, e.bgvideo.videoHeight),
                                     e._alignBGVideo(),
                                     CTween.fadeIn(t(e.bgvideo), 200),
                                 e.selected && e.bgvideo.play())
                             }
                         ))),
                         i.css("opacity", 0),
                         this.$bgvideocont = t("<div></div>").addClass("ms-slide-bgvideocont").append(i),
                         this.hasBG ? this.$imgcont.before(this.$bgvideocont) : this.$bgvideocont.appendTo(this.$element)
                 }
             }
             ,
             i._alignBGVideo = function() {
                 this.bgvideo_fillmode && "none" !== this.bgvideo_fillmode && this.bgVideoAligner.align()
             }
             ,
             i.setSize = function(t, i, e) {
                 this.__width = t,
                 this.slider.options.autoHeight && (this.bgLoaded ? (this.ratio = this.__width / this.bgWidth,
                     i = Math.floor(this.ratio * this.bgHeight),
                     this.$imgcont.height(i)) : (this.ratio = t / this.slider.options.width,
                     i = this.slider.options.height * this.ratio)),
                     this.__height = i,
                     this.$element.width(t).height(i),
                 this.hasBG && this.bgLoaded && this.bgAligner.align(),
                     this._alignBGVideo(),
                 e && this.selected && this.initLayers(e),
                 this.selected && this.locateLayers(),
                 this.hasLayers && (this.slider.options.autoHeight && (this.$layers[0].style.height = this.getHeight() + "px"),
                 "center" == this.slider.options.layersMode && (this.$layers[0].style.left = Math.max(0, (this.__width - this.slider.options.width) / 2) + "px"))
             }
             ,
             i.getHeight = function() {
                 return this.bgLoaded ? this.bgHeight * this.ratio : Math.max(this.$element[0].clientHeight, this.slider.options.height * this.ratio)
             }
             ,
             i.__playVideo = function() {
                 this.vplayed || this.videodis || (this.vplayed = !0,
                 this.slider.api.paused || (this.slider.api.pause(),
                     this.roc = !0),
                     this.vcbtn.css("display", ""),
                     CTween.fadeOut(this.vpbtn, 500, !1),
                     CTween.fadeIn(this.vcbtn, 500),
                     CTween.fadeIn(this.vframe, 500),
                     this.vframe.css("display", "block").attr("src", this.video + "&autoplay=1"),
                     this.view.$element.addClass("ms-def-cursor"),
                     this.view.swipeControl.disable(),
                     this.slider.slideController.dispatchEvent(new MSSliderEvent(MSSliderEvent.VIDEO_PLAY)))
             }
             ,
             i.__closeVideo = function() {
                 if (this.vplayed) {
                     this.vplayed = !1,
                     this.roc && this.slider.api.resume();
                     var t = this;
                     CTween.fadeIn(this.vpbtn, 500),
                         CTween.animate(this.vcbtn, 500, {
                             opacity: 0
                         }, {
                             complete: function() {
                                 t.vcbtn.css("display", "none")
                             }
                         }),
                         CTween.animate(this.vframe, 500, {
                             opacity: 0
                         }, {
                             complete: function() {
                                 t.vframe.attr("src", "about:blank").css("display", "none")
                             }
                         }),
                         this.view.swipeControl.enable(),
                         this.view.$element.removeClass("ms-def-cursor"),
                         this.slider.slideController.dispatchEvent(new MSSliderEvent(MSSliderEvent.VIDEO_CLOSE))
                 }
             }
             ,
             i.create = function() {
                 var i = this;
                 this.hasLayers && (this.$element.append(this.$layers),
                 "center" == this.slider.options.layersMode && this.$layers.css("max-width", this.slider.options.width + "px")),
                 this.link && this.$element.css("cursor", "pointer").click((function() {
                         i.linkdis || window.open(i.link, i.link_targ || "_self")
                     }
                 )),
                 this.video && (-1 === this.video.indexOf("?") && (this.video += "?"),
                     this.vframe = t("<iframe></iframe>").addClass("ms-slide-video").css({
                         width: "100%",
                         height: "100%",
                         display: "none"
                     }).attr("src", "about:blank").appendTo(this.$element),
                     this.vpbtn = t("<div></div>").addClass("ms-slide-vpbtn").click((function() {
                             i.__playVideo()
                         }
                     )).appendTo(this.$element),
                     this.vcbtn = t("<div></div>").addClass("ms-slide-vcbtn").click((function() {
                             i.__closeVideo()
                         }
                     )).appendTo(this.$element).css("display", "none"),
                 window._touch && this.vcbtn.removeClass("ms-slide-vcbtn").addClass("ms-slide-vcbtn-mobile").append('<div class="ms-vcbtn-txt">Close video</div>').appendTo(this.view.$element.parent())),
                 !this.slider.options.autoHeight && this.hasBG && (this.$imgcont.css("height", "100%"),
                 ("center" === this.fillMode || "stretch" === this.fillMode) && (this.fillMode = "fill")),
                     this.sleep()
             }
             ,
             i.destroy = function() {
                 for (var t = 0, i = this.layers.length; t < i; ++t)
                     this.layers[t].$element.stop(!0).remove();
                 this.$element.remove(),
                     this.$element = null
             }
             ,
             i.setup = function() {
                 !this.initBG && this.bgLoaded && (this.initBG = !0,
                     this.$bg_img.css("visibility", ""),
                     this.bgWidth = this.bgNatrualWidth || this.$bg_img.width(),
                     this.bgHeight = this.bgNatrualHeight || this.$bg_img.height(),
                     CTween.fadeIn(this.$imgcont, 300),
                 this.slider.options.autoHeight && this.$imgcont.height(this.bgHeight * this.ratio),
                     this.bgAligner.init(this.bgWidth, this.bgHeight),
                     this.setSize(this.__width, this.__height),
                 this.slider.options.autoHeight && (this.pselected || this.selected) && this.slider.setHeight(this.getHeight()))
             }
             ,
             i.prepareToSelect = function() {
                 this.pselected || this.selected || (this.pselected = !0,
                 (this.link || this.video) && (this.view.addEventListener(MSViewEvents.SWIPE_START, this.onSwipeStart, this),
                     this.view.addEventListener(MSViewEvents.SWIPE_CANCEL, this.onSwipeCancel, this)),
                     this.loadImages(),
                 0 === this.preloadCount && (this.bgvideo && this.bgvideo.play(),
                 this.slider.options.instantStartLayers && this.showLayers()),
                 this.moz && this.$element.css("margin-top", ""))
             }
             ,
             i.select = function() {
                 this.selected || (this.selected = !0,
                     this.pselected = !1,
                     this.$element.addClass("ms-sl-selected"),
                 this.hasLayers && (this.slider.options.autoHeight && (this.$layers[0].style.height = this.getHeight() + "px"),
                 this.slider.options.instantStartLayers || this.showLayers()),
                 0 === this.preloadCount && this.bgvideo && this.bgvideo.play())
             }
             ,
             i.unselect = function() {
                 if (this.pselected = !1,
                 this.moz && this.$element.css("margin-top", "0.1px"),
                 (this.link || this.video) && (this.view.removeEventListener(MSViewEvents.SWIPE_START, this.onSwipeStart, this),
                     this.view.removeEventListener(MSViewEvents.SWIPE_CANCEL, this.onSwipeCancel, this)),
                 this.bgvideo && (this.bgvideo.pause(),
                 !this.autoPauseBgVid && this.vinit && (this.bgvideo.currentTime = 0)),
                     this.selected) {
                     if (this.selected = !1,
                         this.$element.removeClass("ms-sl-selected"),
                         this.hasLayers) {
                         var t = this;
                         t.lht = CTween.animate(this.$layers, 500, {
                             opacity: 0
                         }, {
                             complete: function() {
                                 t.resetLayers()
                             }
                         })
                     }
                     this.video && this.vplayed && (this.__closeVideo(),
                         this.roc = !1)
                 }
             }
             ,
             i.sleep = function() {
                 this.isSleeping || (this.isSleeping = !0,
                 this.autoAppend && this.$element.detach())
             }
             ,
             i.wakeup = function() {
                 this.isSleeping && (this.isSleeping = !1,
                 this.autoAppend && this.view.$slideCont.append(this.$element),
                 this.moz && this.$element.css("margin-top", "0.1px"),
                     this.setup(),
                 this.hasBG && this.bgAligner.align())
             }
     }(jQuery),
     function(t) {
         "use strict";
         var i, e = {};
         window.MSSlideController = function(t) {
             this._delayProgress = 0,
                 this._timer = new averta.Timer(100),
                 this._timer.onTimer = this.onTimer,
                 this._timer.refrence = this,
                 this.currentSlide = null,
                 this.slider = t,
                 this.so = t.options,
                 averta.EventDispatcher.call(this)
         }
             ,
             MSSlideController.registerView = function(t, i) {
                 if (t in e)
                     throw new Error(t + ", is already registered.");
                 e[t] = i
             }
             ,
             MSSlideController.SliderControlList = {},
             MSSlideController.registerControl = function(t, i) {
                 if (t in MSSlideController.SliderControlList)
                     throw new Error(t + ", is already registered.");
                 MSSlideController.SliderControlList[t] = i
             }
             ,
             (i = MSSlideController.prototype).setupView = function() {
                 var i, s, n = this;
                 this.resize_listener = function() {
                     n.__resize()
                 }
                     ,
                     i = {
                         spacing: this.so.space,
                         mouseSwipe: this.so.mouse,
                         loop: this.so.loop,
                         autoHeight: this.so.autoHeight,
                         swipe: this.so.swipe,
                         speed: this.so.speed,
                         dir: this.so.dir,
                         viewNum: this.so.inView,
                         critMargin: this.so.critMargin
                     },
                 this.so.viewOptions && t.extend(i, this.so.viewOptions),
                 this.so.autoHeight && (this.so.heightLimit = !1),
                 (s = e[this.slider.options.view] || MSBasicView)._3dreq && (!window._css3d || t.browser.msie) && (s = s._fallback || MSBasicView),
                     this.view = new s(i),
                 this.so.overPause && (n = this,
                     this.slider.$element.mouseenter((function() {
                             n.is_over = !0,
                                 n._stopTimer()
                         }
                     )).mouseleave((function() {
                             n.is_over = !1,
                                 n._startTimer()
                         }
                     )))
             }
             ,
             i.onChangeStart = function() {
                 this.change_started = !0,
                 this.currentSlide && this.currentSlide.unselect(),
                     this.currentSlide = this.view.currentSlide,
                     this.currentSlide.prepareToSelect(),
                 this.so.endPause && this.currentSlide.index === this.slider.slides.length - 1 && (this.pause(),
                     this.skipTimer()),
                 this.so.autoHeight && this.slider.setHeight(this.currentSlide.getHeight()),
                     this.dispatchEvent(new MSSliderEvent(MSSliderEvent.CHANGE_START))
             }
             ,
             i.onChangeEnd = function() {
                 if (this.change_started = !1,
                     this._startTimer(),
                     this.currentSlide.select(),
                 this.so.preload > 1) {
                     for (var t, i = this.so.preload - 1, e = 1; e <= i; ++e) {
                         if ((t = this.view.index + e) >= this.view.slideList.length) {
                             if (!this.so.loop) {
                                 e = i;
                                 continue
                             }
                             t -= this.view.slideList.length
                         }
                         this.view.slideList[t].loadImages()
                     }
                     for (i > this.view.slideList.length / 2 && (i = Math.floor(this.view.slideList.length / 2)),
                              e = 1; e <= i; ++e) {
                         if ((t = this.view.index - e) < 0) {
                             if (!this.so.loop) {
                                 e = i;
                                 continue
                             }
                             t = this.view.slideList.length + t
                         }
                         this.view.slideList[t].loadImages()
                     }
                 }
                 this.dispatchEvent(new MSSliderEvent(MSSliderEvent.CHANGE_END))
             }
             ,
             i.onSwipeStart = function() {
                 this.skipTimer()
             }
             ,
             i.skipTimer = function() {
                 this._timer.reset(),
                     this._delayProgress = 0,
                     this.dispatchEvent(new MSSliderEvent(MSSliderEvent.WATING))
             }
             ,
             i.onTimer = function() {
                 this._timer.getTime() >= 1e3 * this.view.currentSlide.delay && (this.skipTimer(),
                     this.view.next(),
                     this.hideCalled = !1),
                     this._delayProgress = this._timer.getTime() / (10 * this.view.currentSlide.delay),
                 this.so.hideLayers && !this.hideCalled && 1e3 * this.view.currentSlide.delay - this._timer.getTime() <= 300 && (this.view.currentSlide.hideLayers(),
                     this.hideCalled = !0),
                     this.dispatchEvent(new MSSliderEvent(MSSliderEvent.WATING))
             }
             ,
             i._stopTimer = function() {
                 this._timer && this._timer.stop()
             }
             ,
             i._startTimer = function() {
                 this.paused || this.is_over || !this.currentSlide || !this.currentSlide.ready || this.change_started || this._timer.start()
             }
             ,
             i.__appendSlides = function() {
                 for (var t, i, e = 0, s = this.view.slideList.length - 1; e < s; ++e)
                     (t = this.view.slideList[e]).detached || (t.$element.detach(),
                         t.detached = !0);
                 for (this.view.appendSlide(this.view.slideList[this.view.index]),
                          s = 3,
                          e = 1; e <= s; ++e) {
                     if ((i = this.view.index + e) >= this.view.slideList.length) {
                         if (!this.so.loop) {
                             e = s;
                             continue
                         }
                         i -= this.view.slideList.length
                     }
                     (t = this.view.slideList[i]).detached = !1,
                         this.view.appendSlide(t)
                 }
                 for (s > this.view.slideList.length / 2 && (s = Math.floor(this.view.slideList.length / 2)),
                          e = 1; e <= s; ++e) {
                     if ((i = this.view.index - e) < 0) {
                         if (!this.so.loop) {
                             e = s;
                             continue
                         }
                         i = this.view.slideList.length + i
                     }
                     (t = this.view.slideList[i]).detached = !1,
                         this.view.appendSlide(t)
                 }
             }
             ,
             i.__resize = function(t) {
                 this.created && (this.width = this.slider.$element[0].clientWidth || this.so.width,
                 this.so.fullwidth || (this.width = Math.min(this.width, this.so.width)),
                     this.so.fullheight ? (this.so.heightLimit = !1,
                         this.so.autoHeight = !1,
                         this.height = this.slider.$element[0].clientHeight) : this.height = this.width / this.slider.aspect,
                     this.so.autoHeight ? (this.currentSlide.setSize(this.width, null, t),
                         this.view.setSize(this.width, this.currentSlide.getHeight(), t)) : this.view.setSize(this.width, this.so.heightLimit ? Math.min(this.height, this.so.height) : this.height, t),
                 this.slider.$controlsCont && this.so.centerControls && this.so.fullwidth && this.view.$element.css("left", Math.min(0, -(this.slider.$element[0].clientWidth - this.so.width) / 2) + "px"),
                     this.dispatchEvent(new MSSliderEvent(MSSliderEvent.RESIZE)))
             }
             ,
             i.__dispatchInit = function() {
                 this.dispatchEvent(new MSSliderEvent(MSSliderEvent.INIT))
             }
             ,
             i.setup = function() {
                 if (this.created = !0,
                     this.paused = !this.so.autoplay,
                     this.view.addEventListener(MSViewEvents.CHANGE_START, this.onChangeStart, this),
                     this.view.addEventListener(MSViewEvents.CHANGE_END, this.onChangeEnd, this),
                     this.view.addEventListener(MSViewEvents.SWIPE_START, this.onSwipeStart, this),
                     this.currentSlide = this.view.slides[this.so.start - 1],
                     this.__resize(),
                     this.view.create(this.so.start - 1),
                 0 === this.so.preload && this.view.slides[0].loadImages(),
                     this.scroller = this.view.controller,
                     this.so.wheel) {
                     var i = this
                         , e = (new Date).getTime();
                     this.wheellistener = function(t) {
                         var s, n, o = (new Date).getTime();
                         if (!(o - e < 350))
                             return e = o,
                                 s = window.event || t.orginalEvent || t,
                                 (n = Math.max(-1, Math.min(1, s.wheelDelta || -s.detail))) < 0 ? i.next() : n > 0 && i.previous(),
                                 !1
                     }
                         ,
                         t.browser.mozilla ? this.slider.$element[0].addEventListener("DOMMouseScroll", this.wheellistener) : this.slider.$element.bind("mousewheel", this.wheellistener)
                 }
                 0 === this.slider.$element[0].clientWidth && (this.slider.init_safemode = !0),
                     this.__resize()
             }
             ,
             i.index = function() {
                 return this.view.index
             }
             ,
             i.count = function() {
                 return this.view.slidesCount
             }
             ,
             i.next = function() {
                 this.skipTimer(),
                     this.view.next()
             }
             ,
             i.previous = function() {
                 this.skipTimer(),
                     this.view.previous()
             }
             ,
             i.gotoSlide = function(t) {
                 this.skipTimer(),
                     this.view.gotoSlide(t)
             }
             ,
             i.destroy = function(t) {
                 this.slider.destroy(t)
             }
             ,
             i._destroy = function() {
                 this._timer.reset(),
                     this._timer = null,
                     t(window).unbind("resize", this.resize_listener),
                     this.view.destroy(),
                     this.view = null,
                 this.so.wheel && (t.browser.mozilla ? this.slider.$element[0].removeEventListener("DOMMouseScroll", this.wheellistener) : this.slider.$element.unbind("mousewheel", this.wheellistener),
                     this.wheellistener = null),
                     this.so = null
             }
             ,
             i.update = function(t) {
                 this.slider.init_safemode && t && (this.slider.init_safemode = !1),
                     this.__resize(t)
             }
             ,
             i.locate = function() {
                 this.__resize()
             }
             ,
             i.resume = function() {
                 this.paused && (this.paused = !1,
                     this._startTimer())
             }
             ,
             i.pause = function() {
                 this.paused || (this.paused = !0,
                     this._stopTimer())
             }
             ,
             i.currentTime = function() {
                 return this._delayProgress
             }
             ,
             averta.EventDispatcher.extend(i)
     }(jQuery),
     function(t) {
         "use strict";
         var i, e = {
             image: MSImageLayerElement,
             text: MSLayerElement,
             video: MSVideoLayerElement,
             hotspot: MSHotspotLayer
         };
         window.MasterSlider = function() {
             this.options = {
                 autoplay: !1,
                 loop: !1,
                 mouse: !0,
                 swipe: !0,
                 grabCursor: !0,
                 space: 0,
                 fillMode: "fill",
                 start: 1,
                 view: "basic",
                 width: 400,
                 height: 150,
                 inView: 15,
                 critMargin: 1,
                 heightLimit: !0,
                 smoothHeight: !0,
                 autoHeight: !1,
                 fullwidth: !1,
                 fullheight: !1,
                 autofill: !1,
                 layersMode: "center",
                 hideLayers: !1,
                 endPause: !1,
                 centerControls: !0,
                 overPause: !0,
                 shuffle: !1,
                 speed: 17,
                 dir: "h",
                 preload: 0,
                 wheel: !1,
                 layout: "boxed",
                 fullscreenMargin: 0,
                 instantStartLayers: !1
             },
                 this.slides = [],
                 this.$element = null,
                 this.lastMargin = 0,
                 this.leftSpace = 0,
                 this.topSpace = 0,
                 this.rightSpace = 0,
                 this.bottomSpace = 0;
             var i = this;
             this.resize_listener = function() {
                 i._resize()
             }
                 ,
                 t(window).bind("resize", this.resize_listener)
         }
             ,
             MasterSlider.author = "Averta Ltd. (www.averta.net)",
             MasterSlider.version = "1.5.7",
             MasterSlider.releaseDate = "March 2014",
             (i = MasterSlider.prototype).__setupSlides = function() {
                 var i, e = this, s = 0;
                 this.$element.children(".ms-slide").each((function() {
                         var n, o, a, h, r = t(this);
                         if ((i = new MSSlide).$element = r,
                             i.slider = e,
                             i.delay = void 0 !== r.data("delay") ? r.data("delay") : 3,
                             i.fillMode = void 0 !== r.data("fill-mode") ? r.data("fill-mode") : e.options.fillMode,
                             i.index = s++,
                         (n = r.children("img")).length > 0 && i.setBG(n[0]),
                         (o = r.children("video")).length > 0 && i.setBGVideo(o),
                             e.controls)
                             for (a = 0,
                                      h = e.controls.length; a < h; ++a)
                                 e.controls[a].slideAction(i);
                         r.children("a").each((function() {
                                 var e = t(this);
                                 "video" === this.getAttribute("data-type") ? (i.video = this.getAttribute("href"),
                                     e.remove()) : e.hasClass("ms-layer") || (i.link = this.getAttribute("href"),
                                     i.link_targ = this.getAttribute("target"),
                                     e.remove())
                             }
                         )),
                             e.__createSlideLayers(i, r.find(".ms-layer")),
                             e.slides.push(i),
                             e.slideController.view.addSlide(i)
                     }
                 ))
             }
             ,
             i.__createSlideLayers = function(i, s) {
                 0 != s.length && s.each((function(s, n) {
                         var o, a, h, r, l;
                         "A" === n.nodeName ? o = (a = t(this)).find("img") : o = t(this),
                             (h = new (e[o.data("type") || "text"])).$element = o,
                             h.link = a,
                             r = {},
                             l = {},
                         void 0 !== o.data("effect") && (r.name = o.data("effect")),
                         void 0 !== o.data("ease") && (r.ease = o.data("ease")),
                         void 0 !== o.data("duration") && (r.duration = o.data("duration")),
                         void 0 !== o.data("delay") && (r.delay = o.data("delay")),
                         o.data("hide-effect") && (l.name = o.data("hide-effect")),
                         o.data("hide-ease") && (l.ease = o.data("hide-ease")),
                         void 0 !== o.data("hide-duration") && (l.duration = o.data("hide-duration")),
                         void 0 !== o.data("hide-time") && (l.time = o.data("hide-time")),
                         void 0 !== o.data("resize") && (h.resizable = o.data("resize")),
                         void 0 !== o.data("swipe") && (h.swipe = o.data("swipe")),
                         void 0 !== o.data("widthlimit") && (h.minWidth = o.data("widthlimit")),
                             h.setStartAnim(r),
                             h.setEndAnim(l),
                             i.addLayer(h)
                     }
                 ))
             }
             ,
             i._removeLoading = function() {
                 t(window).unbind("resize", this.resize_listener),
                     this.$element = t("#" + this.id).removeClass("before-init").css("visibility", "visible").css("height", "").css("opacity", 0),
                     CTween.fadeIn(this.$element),
                     this.$loading.remove(),
                 this.slideController && this.slideController.__resize()
             }
             ,
             i._resize = function() {
                 if (this.$loading) {
                     var t = this.$loading[0].clientWidth / this.aspect;
                     t = this.options.heightLimit ? Math.min(t, this.options.height) : t,
                         this.$loading.height(t),
                         this.$element.height(t)
                 }
             }
             ,
             i._shuffleSlides = function() {
                 for (var t, i = this.$element.children(".ms-slide"), e = 0, s = i.length; e < s; ++e)
                     e != (t = Math.floor(Math.random() * (s - 1))) && (this.$element[0].insertBefore(i[e], i[t]),
                         i = this.$element.children(".ms-slide"))
             }
             ,
             i._setupSliderLayout = function() {
                 this._updateSideMargins(),
                     this.lastMargin = this.leftSpace;
                 var i = this.options.layout;
                 "boxed" !== i && "partialview" !== i && (this.options.fullwidth = !0),
                 ("fullscreen" === i || "autofill" === i) && (this.options.fullheight = !0),
                 "partialview" === i && this.$element.addClass("ms-layout-partialview"),
                 ("fullscreen" === i || "fullwidth" === i) && (t(window).bind("resize", {
                     that: this
                 }, this._updateLayout),
                     this._updateLayout()),
                     t(window).bind("resize", this.slideController.resize_listener)
             }
             ,
             i._updateLayout = function(i) {
                 var e, s = i ? i.data.that : this, n = s.options.layout, o = s.$element;
                 o.width(t("body").innerWidth() - s.leftSpace - s.rightSpace),
                     e = -o.offset().left + s.leftSpace + s.lastMargin,
                     o.css("margin-left", e),
                     s.lastMargin = e,
                 "fullscreen" === n && o.height(window.innerHeight - s.options.fullscreenMargin - s.topSpace - s.bottomSpace)
             }
             ,
             i._init = function() {
                 var i, e, s;
                 if (!this.preventInit) {
                     if (this.initialized = !0,
                     "all" !== this.options.preload && this._removeLoading(),
                     this.options.shuffle && this._shuffleSlides(),
                         MSLayerEffects.setup(),
                         this.slideController.setupView(),
                         this.view = this.slideController.view,
                         this.controls) {
                         for (this.$controlsCont = t("<div></div>").addClass("ms-container").appendTo(this.$element),
                              this.options.centerControls && this.$controlsCont.css("max-width", this.options.width + "px"),
                                  i = 0,
                                  e = this.controls.length; i < e; ++i)
                             this.controls[i].setup();
                         this.$controlsCont.prepend(this.view.$element)
                     } else
                         this.$element.append(this.view.$element);
                     if (this._setupSliderLayout(),
                         this.__setupSlides(),
                         this.slideController.setup(),
                         this.controls)
                         for (i = 0,
                                  e = this.controls.length; i < e; ++i)
                             this.controls[i].create();
                     this.options.autoHeight && this.slideController.view.$element.height(this.slideController.currentSlide.getHeight()),
                     this.options.swipe && !window._touch && this.options.grabCursor && this.options.mouse && ((s = this.view.$element).mousedown((function() {
                             s.removeClass("ms-grab-cursor"),
                                 s.addClass("ms-grabbing-cursor")
                         }
                     )).addClass("ms-grab-cursor"),
                         t(document).mouseup((function() {
                                 s.removeClass("ms-grabbing-cursor"),
                                     s.addClass("ms-grab-cursor")
                             }
                         ))),
                         this.slideController.__dispatchInit()
                 }
             }
             ,
             i.setHeight = function(t) {
                 this.options.smoothHeight ? (this.htween && (this.htween.reset ? this.htween.reset() : this.htween.stop(!0)),
                     this.htween = CTween.animate(this.slideController.view.$element, 500, {
                         height: t
                     }, {
                         ease: "easeOutQuart"
                     })) : this.slideController.view.$element.height(t)
             }
             ,
             i.reserveSpace = function(t, i) {
                 var e = t + "Space"
                     , s = this[e];
                 return this[e] += i,
                     this._updateSideMargins(),
                     s
             }
             ,
             i._updateSideMargins = function() {
                 this.$element.css("margin", this.topSpace + "px " + this.rightSpace + "px " + this.bottomSpace + "px " + this.leftSpace + "px")
             }
             ,
             i._realignControls = function() {
                 this.rightSpace = this.leftSpace = this.topSpace = this.bottomSpace = 0,
                     this._updateSideMargins(),
                     this.api.dispatchEvent(new MSSliderEvent(MSSliderEvent.RESERVED_SPACE_CHANGE))
             }
             ,
             i.control = function(t, i) {
                 if (t in MSSlideController.SliderControlList) {
                     this.controls || (this.controls = []);
                     var e = new MSSlideController.SliderControlList[t](i);
                     return e.slider = this,
                         this.controls.push(e),
                         this
                 }
             }
             ,
             i.setup = function(i, e) {
                 var s;
                 if (this.id = i,
                     this.$element = "string" == typeof i ? t("#" + i) : i.eq(0),
                     this.setupMarkup = this.$element.html(),
                 0 !== this.$element.length)
                     return this.$element.addClass("master-slider").addClass("before-init"),
                     t.browser.msie && this.$element.addClass("ms-ie").addClass("ms-ie" + t.browser.version.slice(0, t.browser.version.indexOf("."))),
                     navigator.userAgent.toLowerCase().indexOf("android") > -1 && this.$element.addClass("ms-android"),
                         s = this,
                         t.extend(this.options, e),
                         this.aspect = this.options.width / this.options.height,
                         this.$loading = t("<div></div>").addClass("ms-loading-container").insertBefore(this.$element).append(t("<div></div>").addClass("ms-loading")),
                         this.$loading.parent().css("position", "relative"),
                     this.options.autofill && (this.options.fullwidth = !0,
                         this.options.fullheight = !0),
                     this.options.fullheight && this.$element.addClass("ms-fullheight"),
                         this._resize(),
                         this.slideController = new MSSlideController(this),
                         this.api = this.slideController,
                         t(document).ready((function() {
                                 s._init()
                             }
                         )),
                         this;
                 console && console.log("Master Slider Error: #" + i + " not found.")
             }
             ,
             i.destroy = function(i) {
                 var e, s, n;
                 if (this.controls)
                     for (e = 0,
                              s = this.controls.length; e !== s; e++)
                         this.controls[e].destroy();
                 this.slideController && this.slideController._destroy(),
                 this.$loading && this.$loading.remove(),
                     i ? this.$element.html(this.setupMarkup).css("visibility", "hidden") : this.$element.remove(),
                 ("fullscreen" === (n = this.options.layout) || "fullwidth" === n) && t(window).unbind("resize", this._updateLayout)
             }
     }(jQuery),
     window.MSViewEvents = function(t) {
         this.type = t
     }
     ,
     MSViewEvents.SWIPE_START = "swipeStart",
     MSViewEvents.SWIPE_END = "swipeEnd",
     MSViewEvents.SWIPE_MOVE = "swipeMove",
     MSViewEvents.SWIPE_CANCEL = "swipeCancel",
     MSViewEvents.SCROLL = "scoll",
     MSViewEvents.CHANGE_START = "slideChangeStart",
     MSViewEvents.CHANGE_END = "slideChangeEnd",
     function(t) {
         "use strict";
         window.MSBasicView = function(i) {
             this.options = {
                 loop: !1,
                 dir: "h",
                 autoHeight: !1,
                 spacing: 5,
                 mouseSwipe: !0,
                 swipe: !0,
                 speed: 17,
                 minSlideSpeed: 2,
                 viewNum: 20,
                 critMargin: 1
             },
                 t.extend(this.options, i),
                 this.dir = this.options.dir,
                 this.loop = this.options.loop,
                 this.spacing = this.options.spacing,
                 this.__width = 0,
                 this.__height = 0,
                 this.__cssProb = "h" === this.dir ? "left" : "top",
                 this.__offset = "h" === this.dir ? "offsetLeft" : "offsetTop",
                 this.__dimension = "h" === this.dir ? "__width" : "__height",
                 this.__translate_end = window._css3d ? " translateZ(0px)" : "",
                 this.$slideCont = t("<div></div>").addClass("ms-slide-container"),
                 this.$element = t("<div></div>").addClass("ms-view").addClass("ms-basic-view").append(this.$slideCont),
                 this.currentSlide = null,
                 this.index = -1,
                 this.slidesCount = 0,
                 this.slides = [],
                 this.slideList = [],
                 this.viewSlidesList = [],
                 this.css3 = window._cssanim,
                 this.start_buffer = 0,
                 this.firstslide_snap = 0,
                 this.controller = new Controller(0,0,{
                     snapping: !0,
                     snapsize: 100,
                     paging: !0,
                     snappingMinSpeed: this.options.minSlideSpeed,
                     friction: (100 - .5 * this.options.speed) / 100,
                     endless: this.loop
                 }),
                 this.controller.renderCallback("h" === this.dir ? this._horizUpdate : this._vertiUpdate, this),
                 this.controller.snappingCallback(this.__snapUpdate, this),
                 this.controller.snapCompleteCallback(this.__snapCompelet, this),
                 averta.EventDispatcher.call(this)
         }
         ;
         var i = MSBasicView.prototype;
         i.__snapCompelet = function() {
             this.__locateSlides(),
                 this.start_buffer = 0,
                 this.dispatchEvent(new MSViewEvents(MSViewEvents.CHANGE_END))
         }
             ,
             i.__snapUpdate = function(i, e, s) {
                 var n, o;
                 if (this.loop)
                     n = this.index + s,
                         this.updateLoop(n),
                     n >= this.slidesCount && (n -= this.slidesCount),
                     n < 0 && (n = this.slidesCount + n),
                         this.index = n;
                 else {
                     if (e < 0 || e >= this.slidesCount)
                         return;
                     this.index = e
                 }
                 this._checkCritMargins(),
                 t.browser.mozilla && (this.slideList[this.index].$element[0].style.marginTop = "0.1px",
                 this.currentSlide && (this.currentSlide.$element[0].style.marginTop = "")),
                 (o = this.slideList[this.index]) !== this.currentSlide && (this.currentSlide = o,
                     this.dispatchEvent(new MSViewEvents(MSViewEvents.CHANGE_START)))
             }
             ,
             i._checkCritMargins = function() {
                 if (!this.normalMode) {
                     var t = Math.floor(this.options.viewNum / 2)
                         , i = this.viewSlidesList.indexOf(this.slideList[this.index])
                         , e = this[this.__dimension] + this.spacing
                         , s = this.options.critMargin;
                     if (this.loop)
                         return void ((i <= s || i >= this.viewSlidesList.length - s) && (e *= i - t,
                             this.__locateSlides(!1, e + this.start_buffer),
                             this.start_buffer += e));
                     (i < s && this.index >= s || i >= this.viewSlidesList.length - s && this.index < this.slidesCount - s) && this.__locateSlides(!1)
                 }
             }
             ,
             i._vertiUpdate = function(t, i) {
                 this.__contPos = i,
                     this.dispatchEvent(new MSViewEvents(MSViewEvents.SCROLL)),
                     this.css3 ? this.$slideCont[0].style[window._jcsspfx + "Transform"] = "translateY(" + -i + "px)" + this.__translate_end : this.$slideCont[0].style.top = -i + "px"
             }
             ,
             i._horizUpdate = function(t, i) {
                 this.__contPos = i,
                     this.dispatchEvent(new MSViewEvents(MSViewEvents.SCROLL)),
                     this.css3 ? this.$slideCont[0].style[window._jcsspfx + "Transform"] = "translateX(" + -i + "px)" + this.__translate_end : this.$slideCont[0].style.left = -i + "px"
             }
             ,
             i.__updateViewList = function() {
                 var t, i, e, s;
                 if (this.normalMode)
                     this.viewSlidesList = this.slides;
                 else {
                     if (t = this.viewSlidesList.slice(),
                         this.viewSlidesList = [],
                         i = 0,
                         e = Math.floor(this.options.viewNum / 2),
                         this.loop)
                         for (; i !== this.options.viewNum; i++)
                             this.viewSlidesList.push(this.slides[this.currentSlideLoc - e + i]);
                     else {
                         for (i = 0; i !== e && this.index - i != -1; i++)
                             this.viewSlidesList.unshift(this.slideList[this.index - i]);
                         for (i = 1; i !== e && this.index + i !== this.slidesCount; i++)
                             this.viewSlidesList.push(this.slideList[this.index + i])
                     }
                     for (i = 0,
                              s = t.length; i !== s; i++)
                         -1 === this.viewSlidesList.indexOf(t[i]) && t[i].sleep();
                     t = null
                 }
             }
             ,
             i.__locateSlides = function(t, i) {
                 var e, s, n, o;
                 for (this.__updateViewList(),
                          i = this.loop ? i || 0 : this.slides.indexOf(this.viewSlidesList[0]) * (this[this.__dimension] + this.spacing),
                          e = this.viewSlidesList.length,
                          n = 0; n !== e; n++)
                     o = i + n * (this[this.__dimension] + this.spacing),
                         (s = this.viewSlidesList[n]).wakeup(),
                         s.position = o,
                         s.$element[0].style[this.__cssProb] = o + "px";
                 !1 !== t && this.controller.changeTo(this.slideList[this.index].position, !1, null, null, !1)
             }
             ,
             i.__createLoopList = function() {
                 var t = []
                     , i = 0
                     , e = this.slidesCount / 2
                     , s = this.slidesCount % 2 == 0 ? e - 1 : Math.floor(e)
                     , n = this.slidesCount % 2 == 0 ? e : Math.floor(e);
                 for (this.currentSlideLoc = s,
                          i = 1; i <= s; ++i)
                     t.unshift(this.slideList[this.index - i < 0 ? this.slidesCount - i + this.index : this.index - i]);
                 for (t.push(this.slideList[this.index]),
                          i = 1; i <= n; ++i)
                     t.push(this.slideList[this.index + i >= this.slidesCount ? this.index + i - this.slidesCount : this.index + i]);
                 return t
             }
             ,
             i.__getSteps = function(t, i) {
                 var e = i < t ? this.slidesCount - t + i : i - t
                     , s = Math.abs(this.slidesCount - e);
                 return e < s ? e : -s
             }
             ,
             i.__pushEnd = function() {
                 var t, i = this.slides.shift(), e = this.slides[this.slidesCount - 2];
                 this.slides.push(i),
                 this.normalMode && (t = e.$element[0][this.__offset] + this.spacing + this[this.__dimension],
                     i.$element[0].style[this.__cssProb] = t + "px",
                     i.position = t)
             }
             ,
             i.__pushStart = function() {
                 var t, i = this.slides.pop(), e = this.slides[0];
                 this.slides.unshift(i),
                 this.normalMode && (t = e.$element[0][this.__offset] - this.spacing - this[this.__dimension],
                     i.$element[0].style[this.__cssProb] = t + "px",
                     i.position = t)
             }
             ,
             i.addSlide = function(t) {
                 t.view = this,
                     this.slides.push(t),
                     this.slideList.push(t),
                     this.slidesCount++
             }
             ,
             i.appendSlide = function(t) {
                 this.$slideCont.append(t.$element)
             }
             ,
             i.updateLoop = function(t) {
                 var i, e, s;
                 if (this.loop)
                     for (i = this.__getSteps(this.index, t),
                              e = 0,
                              s = Math.abs(i); e < s; ++e)
                         i < 0 ? this.__pushStart() : this.__pushEnd()
             }
             ,
             i.gotoSlide = function(t, i) {
                 this.updateLoop(t),
                     this.index = t;
                 var e = this.slideList[this.index];
                 this._checkCritMargins(),
                     this.controller.changeTo(e.position, !i, null, null, !1),
                 e !== this.currentSlide && (this.currentSlide = e,
                     this.dispatchEvent(new MSViewEvents(MSViewEvents.CHANGE_START)),
                 i && this.dispatchEvent(new MSViewEvents(MSViewEvents.CHANGE_END)))
             }
             ,
             i.next = function() {
                 this.gotoSlide(this.index + 1 >= this.slidesCount ? 0 : this.index + 1)
             }
             ,
             i.previous = function() {
                 this.gotoSlide(this.index - 1 < 0 ? this.slidesCount - 1 : this.index - 1)
             }
             ,
             i.setupSwipe = function() {
                 this.swipeControl = new averta.TouchSwipe(this.$element),
                     this.swipeControl.swipeType = "h" === this.dir ? "horizontal" : "vertical";
                 var t = this;
                 this.swipeControl.onSwipe = "h" === this.dir ? function(i) {
                         t.horizSwipeMove(i)
                     }
                     : function(i) {
                         t.vertSwipeMove(i)
                     }
             }
             ,
             i.vertSwipeMove = function(t) {
                 var i, e = t.phase;
                 "start" === e ? (this.controller.stop(),
                     this.dispatchEvent(new MSViewEvents(MSViewEvents.SWIPE_START))) : "move" === e && (!this.loop || Math.abs(this.currentSlide.position - this.controller.value + t.moveY) < this.cont_size / 2) ? this.controller.drag(t.moveY) : ("end" === e || "cancel" === e) && (i = t.distanceY / t.duration * 50 / 3,
                     Math.abs(i) > .1 ? (this.controller.push(-i),
                     i > this.controller.options.snappingMinSpeed && this.dispatchEvent(new MSViewEvents(MSViewEvents.SWIPE_END))) : (this.controller.cancel(),
                         this.dispatchEvent(new MSViewEvents(MSViewEvents.SWIPE_CANCEL))))
             }
             ,
             i.horizSwipeMove = function(t) {
                 var i, e = t.phase;
                 "start" === e ? (this.controller.stop(),
                     this.dispatchEvent(new MSViewEvents(MSViewEvents.SWIPE_START))) : "move" === e && (!this.loop || Math.abs(this.currentSlide.position - this.controller.value + t.moveX) < this.cont_size / 2) ? this.controller.drag(t.moveX) : ("end" === e || "cancel" === e) && (i = t.distanceX / t.duration * 50 / 3,
                     Math.abs(i) > .1 ? (this.controller.push(-i),
                     i > this.controller.options.snappingMinSpeed && this.dispatchEvent(new MSViewEvents(MSViewEvents.SWIPE_END))) : (this.controller.cancel(),
                         this.dispatchEvent(new MSViewEvents(MSViewEvents.SWIPE_CANCEL))))
             }
             ,
             i.setSize = function(t, i, e) {
                 if (this.lastWidth !== t || i !== this.lastHeight || e) {
                     this.$element.width(t).height(i);
                     for (var s = 0; s < this.slidesCount; ++s)
                         this.slides[s].setSize(t, i, e);
                     this.__width = t,
                         this.__height = i,
                     this.__created && (this.__locateSlides(),
                         this.cont_size = (this.slidesCount - 1) * (this[this.__dimension] + this.spacing),
                     this.loop || (this.controller._max_value = this.cont_size),
                         this.controller.options.snapsize = this[this.__dimension] + this.spacing,
                         this.controller.changeTo(this.currentSlide.position, !1, null, null, !1),
                         this.controller.cancel(),
                         this.lastWidth = t,
                         this.lastHeight = i)
                 }
             }
             ,
             i.create = function(t) {
                 this.__created = !0,
                     this.index = Math.min(t || 0, this.slidesCount - 1),
                 this.loop && (this.slides = this.__createLoopList()),
                     this.normalMode = this.slidesCount <= this.options.viewNum,
                     this.__locateSlides();
                 for (var i = 0; i < this.slidesCount; ++i)
                     this.slides[i].create();
                 this.controller.options.snapsize = this[this.__dimension] + this.spacing,
                 this.loop || (this.controller._max_value = (this.slidesCount - 1) * (this[this.__dimension] + this.spacing)),
                     this.gotoSlide(this.index, !0),
                 this.options.swipe && (window._touch || this.options.mouseSwipe) && this.setupSwipe()
             }
             ,
             i.destroy = function() {
                 if (this.__created) {
                     for (var t = 0; t < this.slidesCount; ++t)
                         this.slides[t].destroy();
                     this.slides = null,
                         this.slideList = null,
                         this.$element.remove(),
                         this.controller.destroy(),
                         this.controller = null
                 }
             }
             ,
             averta.EventDispatcher.extend(i),
             MSSlideController.registerView("basic", MSBasicView)
     }(jQuery),
     function() {
         "use strict";
         window.MSWaveView = function(t) {
             MSBasicView.call(this, t),
                 this.$element.removeClass("ms-basic-view").addClass("ms-wave-view"),
                 this.$slideCont.css(window._csspfx + "transform-style", "preserve-3d")
         }
             ,
             MSWaveView.extend(MSBasicView),
             MSWaveView._3dreq = !0,
             MSWaveView._fallback = MSBasicView;
         var t = MSWaveView.prototype
             , i = MSBasicView.prototype;
         t._horizUpdate = function(t, e) {
             var s, n, o, a;
             for (i._horizUpdate.call(this, t, e),
                      s = -e,
                      a = 0; a < this.slidesCount; ++a)
                 o = -s - (n = this.slideList[a]).position,
                     this.__updateSlidesHoriz(n, o)
         }
             ,
             t._vertiUpdate = function(t, e) {
                 var s, n, o, a;
                 for (i._vertiUpdate.call(this, t, e),
                          s = -e,
                          a = 0; a < this.slidesCount; ++a)
                     o = -s - (n = this.slideList[a]).position,
                         this.__updateSlidesVertic(n, o)
             }
             ,
             t.__updateSlidesHoriz = function(t, i) {
                 var e = Math.abs(100 * i / this.__width);
                 t.$element.css(window._csspfx + "transform", "translateZ(" + 3 * -e + "px) rotateY(0.01deg)")
             }
             ,
             t.__updateSlidesVertic = function(t, i) {
                 this.__updateSlidesHoriz(t, i)
             }
             ,
             MSSlideController.registerView("wave", MSWaveView)
     }(jQuery),
     function() {
         window.MSFadeBasicView = function(t) {
             MSWaveView.call(this, t),
                 this.$element.removeClass("ms-wave-view").addClass("ms-fade-basic-view")
         }
             ,
             MSFadeBasicView.extend(MSWaveView);
         var t = MSFadeBasicView.prototype;
         MSFadeBasicView.prototype;
         t.__updateSlidesHoriz = function(t, i) {
             var e = Math.abs(.6 * i / this.__width);
             e = 1 - Math.min(e, .6),
                 t.$element.css("opacity", e)
         }
             ,
             t.__updateSlidesVertic = function(t, i) {
                 this.__updateSlidesHoriz(t, i)
             }
             ,
             MSSlideController.registerView("fadeBasic", MSFadeBasicView),
             MSWaveView._fallback = MSFadeBasicView
     }(),
     function() {
         window.MSFadeWaveView = function(t) {
             MSWaveView.call(this, t),
                 this.$element.removeClass("ms-wave-view").addClass("ms-fade-wave-view")
         }
             ,
             MSFadeWaveView.extend(MSWaveView),
             MSFadeWaveView._3dreq = !0,
             MSFadeWaveView._fallback = MSFadeBasicView;
         var t = MSFadeWaveView.prototype;
         MSWaveView.prototype;
         t.__updateSlidesHoriz = function(t, i) {
             var e = Math.abs(100 * i / this.__width);
             e = Math.min(e, 100),
                 t.$element.css("opacity", 1 - e / 300),
                 t.$element.css(window._csspfx + "transform", "scale(" + (1 - e / 800) + ") rotateY(0.01deg) ")
         }
             ,
             t.__updateSlidesVertic = function(t, i) {
                 this.__updateSlidesHoriz(t, i)
             }
             ,
             MSSlideController.registerView("fadeWave", MSFadeWaveView)
     }(),
     function() {
         "use strict";
         window.MSFlowView = function(t) {
             MSWaveView.call(this, t),
                 this.$element.removeClass("ms-wave-view").addClass("ms-flow-view")
         }
             ,
             MSFlowView.extend(MSWaveView),
             MSFlowView._3dreq = !0,
             MSFlowView._fallback = MSFadeBasicView;
         var t = MSFlowView.prototype;
         MSWaveView.prototype;
         t.__updateSlidesHoriz = function(t, i) {
             var e = Math.abs(100 * i / this.__width)
                 , s = Math.min(.3 * e, 30) * (i < 0 ? -1 : 1)
                 , n = 1.2 * e;
             t.$element[0].style[window._jcsspfx + "Transform"] = "translateZ(" + 5 * -n + "px) rotateY(" + s + "deg) "
         }
             ,
             t.__updateSlidesVertic = function(t, i) {
                 var e = Math.abs(100 * i / this.__width)
                     , s = Math.min(.3 * e, 30) * (i < 0 ? -1 : 1)
                     , n = 1.2 * e;
                 t.$element[0].style[window._jcsspfx + "Transform"] = "translateZ(" + 5 * -n + "px) rotateX(" + -s + "deg) "
             }
             ,
             MSSlideController.registerView("flow", MSFlowView)
     }(jQuery),
     function() {
         window.MSFadeFlowView = function(t) {
             MSWaveView.call(this, t),
                 this.$element.removeClass("ms-wave-view").addClass("ms-fade-flow-view")
         }
             ,
             MSFadeFlowView.extend(MSWaveView),
             MSFadeFlowView._3dreq = !0;
         var t = MSFadeFlowView.prototype;
         MSWaveView.prototype;
         t.__calculate = function(t) {
             var i = Math.min(Math.abs(100 * t / this.__width), 100);
             return {
                 value: i,
                 rvalue: Math.min(.5 * i, 50) * (t < 0 ? -1 : 1)
             }
         }
             ,
             t.__updateSlidesHoriz = function(t, i) {
                 var e = this.__calculate(i);
                 t.$element.css("opacity", 1 - e.value / 300),
                     t.$element[0].style[window._csspfx + "transform"] = "translateZ(" + -e.value + "px) rotateY(" + e.rvalue + "deg) "
             }
             ,
             t.__updateSlidesVertic = function(t, i) {
                 var e = this.__calculate(i);
                 t.$element.css("opacity", 1 - e.value / 300),
                     t.$element[0].style[window._csspfx + "transform"] = "translateZ(" + -e.value + "px) rotateX(" + -e.rvalue + "deg) "
             }
             ,
             MSSlideController.registerView("fadeFlow", MSFadeFlowView)
     }(),
     function(t) {
         "use strict";
         window.MSMaskView = function(t) {
             MSBasicView.call(this, t),
                 this.$element.removeClass("ms-basic-view").addClass("ms-mask-view")
         }
             ,
             MSMaskView.extend(MSBasicView);
         var i = MSMaskView.prototype
             , e = MSBasicView.prototype;
         i.addSlide = function(i) {
             i.view = this,
                 i.$frame = t("<div></div>").addClass("ms-mask-frame").append(i.$element),
                 i.$element[0].style.position = "relative",
                 i.autoAppend = !1,
                 this.slides.push(i),
                 this.slideList.push(i),
                 this.slidesCount++
         }
             ,
             i.setSize = function(t, i) {
                 for (var s = this.slides[0].slider, n = 0; n < this.slidesCount; ++n)
                     this.slides[n].$frame[0].style.width = t + "px",
                     s.options.autoHeight || (this.slides[n].$frame[0].style.height = i + "px");
                 e.setSize.call(this, t, i)
             }
             ,
             i._horizUpdate = function(t, i) {
                 e._horizUpdate.call(this, t, i);
                 var s = 0;
                 if (this.css3)
                     for (s = 0; s < this.slidesCount; ++s)
                         this.slideList[s].$element[0].style[window._jcsspfx + "Transform"] = "translateX(" + (i - this.slideList[s].position) + "px)" + this.__translate_end;
                 else
                     for (s = 0; s < this.slidesCount; ++s)
                         this.slideList[s].$element[0].style.left = i - this.slideList[s].position + "px"
             }
             ,
             i._vertiUpdate = function(t, i) {
                 e._vertiUpdate.call(this, t, i);
                 var s = 0;
                 if (this.css3)
                     for (s = 0; s < this.slidesCount; ++s)
                         this.slideList[s].$element[0].style[window._jcsspfx + "Transform"] = "translateY(" + (i - this.slideList[s].position) + "px)" + this.__translate_end;
                 else
                     for (s = 0; s < this.slidesCount; ++s)
                         this.slideList[s].$element[0].style.top = i - this.slideList[s].position + "px"
             }
             ,
             i.__pushEnd = function() {
                 var t, i = this.slides.shift(), e = this.slides[this.slidesCount - 2];
                 this.slides.push(i),
                 this.normalMode && (t = e.$frame[0][this.__offset] + this.spacing + this[this.__dimension],
                     i.$frame[0].style[this.__cssProb] = t + "px",
                     i.position = t)
             }
             ,
             i.__pushStart = function() {
                 var t, i = this.slides.pop(), e = this.slides[0];
                 this.slides.unshift(i),
                 this.normalMode && (t = e.$frame[0][this.__offset] - this.spacing - this[this.__dimension],
                     i.$frame[0].style[this.__cssProb] = t + "px",
                     i.position = t)
             }
             ,
             i.__updateViewList = function() {
                 var t, i, e, s;
                 if (this.normalMode)
                     this.viewSlidesList = this.slides;
                 else {
                     if (t = this.viewSlidesList.slice(),
                         this.viewSlidesList = [],
                         i = 0,
                         e = Math.floor(this.options.viewNum / 2),
                         this.loop)
                         for (; i !== this.options.viewNum; i++)
                             this.viewSlidesList.push(this.slides[this.currentSlideLoc - e + i]);
                     else {
                         for (i = 0; i !== e && this.index - i != -1; i++)
                             this.viewSlidesList.unshift(this.slideList[this.index - i]);
                         for (i = 1; i !== e && this.index + i !== this.slidesCount; i++)
                             this.viewSlidesList.push(this.slideList[this.index + i])
                     }
                     for (i = 0,
                              s = t.length; i !== s; i++)
                         -1 === this.viewSlidesList.indexOf(t[i]) && (t[i].sleep(),
                             t[i].$frame.detach());
                     t = null
                 }
             }
             ,
             i.__locateSlides = function(t, i) {
                 var e, s, n, o;
                 for (this.__updateViewList(),
                          i = this.loop ? i || 0 : this.slides.indexOf(this.viewSlidesList[0]) * (this[this.__dimension] + this.spacing),
                          e = this.viewSlidesList.length,
                          n = 0; n !== e; n++)
                     o = i + n * (this[this.__dimension] + this.spacing),
                         s = this.viewSlidesList[n],
                         this.$slideCont.append(s.$frame),
                         s.wakeup(!1),
                         s.position = o,
                         s.$frame[0].style[this.__cssProb] = o + "px";
                 !1 !== t && this.controller.changeTo(this.slideList[this.index].position, !1, null, null, !1)
             }
             ,
             MSSlideController.registerView("mask", MSMaskView)
     }(jQuery),
     function() {
         "use strict";
         window.MSFadeView = function(t) {
             MSBasicView.call(this, t),
                 this.$element.removeClass("ms-basic-view").addClass("ms-fade-view"),
                 this.controller.renderCallback(this.__update, this)
         }
             ,
             MSFadeView.extend(MSBasicView);
         var t = MSFadeView.prototype
             , i = MSBasicView.prototype;
         t.__update = function(t, i) {
             for (var e, s, n = -i, o = 0; o < this.slidesCount; ++o)
                 s = -n - (e = this.slideList[o]).position,
                     this.__updateSlides(e, s)
         }
             ,
             t.__updateSlides = function(t, i) {
                 var e = Math.abs(i / this[this.__dimension]);
                 1 - e <= 0 ? t.$element.fadeTo(0, 0).css("visibility", "hidden") : t.$element.fadeTo(0, 1 - e).css("visibility", "")
             }
             ,
             t.__locateSlides = function(t, i) {
                 var e, s, n, o;
                 for (this.__updateViewList(),
                          i = this.loop ? i || 0 : this.slides.indexOf(this.viewSlidesList[0]) * (this[this.__dimension] + this.spacing),
                          e = this.viewSlidesList.length,
                          n = 0; n !== e; n++)
                     o = i + n * this[this.__dimension],
                         (s = this.viewSlidesList[n]).wakeup(),
                         s.position = o;
                 !1 !== t && this.controller.changeTo(this.slideList[this.index].position, !1, null, null, !1)
             }
             ,
             t.__pushEnd = function() {
                 var t = this.slides.shift()
                     , i = this.slides[this.slidesCount - 2];
                 this.slides.push(t),
                     t.position = i.position + this[this.__dimension]
             }
             ,
             t.__pushStart = function() {
                 var t = this.slides.pop()
                     , i = this.slides[0];
                 this.slides.unshift(t),
                     t.position = i.position - this[this.__dimension]
             }
             ,
             t.create = function(t) {
                 i.create.call(this, t),
                     this.spacing = 0,
                     this.controller.options.minValidDist = 10
             }
             ,
             MSSlideController.registerView("fade", MSFadeView)
     }(jQuery),
     function() {
         "use strict";
         window.MSScaleView = function(t) {
             MSBasicView.call(this, t),
                 this.$element.removeClass("ms-basic-view").addClass("ms-scale-view"),
                 this.controller.renderCallback(this.__update, this)
         }
             ,
             MSScaleView.extend(MSFadeView);
         var t = MSScaleView.prototype
             , i = MSFadeView.prototype;
         t.__updateSlides = function(t, i) {
             var e = Math.abs(i / this[this.__dimension]);
             1 - e <= 0 ? t.$element.fadeTo(0, 0).css("visibility", "hidden") : t.$element.fadeTo(0, 1 - e).css("visibility", "").css(window._jcsspfx + "Transform", "perspective(2000px) translateZ(" + e * (i < 0 ? -.5 : .5) * 300 + "px)")
         }
             ,
             t.create = function(t) {
                 i.create.call(this, t),
                     this.controller.options.minValidDist = .03
             }
             ,
             MSSlideController.registerView("scale", MSScaleView)
     }(jQuery),
     function() {
         "use strict";
         var t, i = 2e3;
         window.MSFocusView = function(t) {
             MSWaveView.call(this, t),
                 this.$element.removeClass("ms-wave-view").addClass("ms-focus-view"),
                 this.options.centerSpace = this.options.centerSpace || 1
         }
             ,
             MSFocusView.extend(MSWaveView),
             MSFocusView._3dreq = !0,
             MSFocusView._fallback = MSFadeBasicView,
             t = MSFocusView.prototype,
             MSWaveView.prototype,
             t.__calcview = function(t, e) {
                 return e / 2 * t / (t + i) * (t + i) / i
             }
             ,
             t.__updateSlidesHoriz = function(t, i) {
                 var e = Math.abs(100 * i / this.__width);
                 e = 15 * -Math.min(e, 100),
                     t.$element.css(window._csspfx + "transform", "translateZ(" + e + "px) rotateY(0.01deg) translateX(" + (i < 0 ? 1 : -1) * -this.__calcview(e, this.__width) * this.options.centerSpace + "px)")
             }
             ,
             t.__updateSlidesVertic = function(t, i) {
                 var e = Math.abs(100 * i / this.__width);
                 e = 15 * -Math.min(e, 100),
                     t.$element.css(window._csspfx + "transform", "translateZ(" + e + "px) rotateY(0.01deg) translateY(" + (i < 0 ? 1 : -1) * -this.__calcview(e, this.__width) * this.options.centerSpace + "px)")
             }
             ,
             MSSlideController.registerView("focus", MSFocusView)
     }(),
     function() {
         window.MSPartialWaveView = function(t) {
             MSWaveView.call(this, t),
                 this.$element.removeClass("ms-wave-view").addClass("ms-partial-wave-view")
         }
             ,
             MSPartialWaveView.extend(MSWaveView),
             MSPartialWaveView._3dreq = !0,
             MSPartialWaveView._fallback = MSFadeBasicView;
         var t = MSPartialWaveView.prototype;
         MSWaveView.prototype;
         t.__updateSlidesHoriz = function(t, i) {
             var e = Math.abs(100 * i / this.__width);
             t.$bg_img.css("opacity", (100 - Math.abs(120 * i / this.__width / 3)) / 100),
                 t.$element.css(window._csspfx + "transform", "translateZ(" + 3 * -e + "px) rotateY(0.01deg) translateX(" + .75 * i + "px)")
         }
             ,
             t.__updateSlidesVertic = function(t, i) {
                 var e = Math.abs(100 * i / this.__width);
                 t.$bg_img.css("opacity", (100 - Math.abs(120 * i / this.__width / 3)) / 100),
                     t.$element.css(window._csspfx + "transform", "translateZ(" + 3 * -e + "px) rotateY(0.01deg) translateY(" + .75 * i + "px)")
             }
             ,
             MSSlideController.registerView("partialWave", MSPartialWaveView)
     }(),
     function(t) {
         "use strict";
         var i = function() {
             this.options = {
                 prefix: "ms-",
                 autohide: !0,
                 overVideo: !0
             }
         }
             , e = i.prototype;
         e.slideAction = function() {}
             ,
             e.setup = function() {
                 this.cont = this.options.insertTo ? t(this.options.insertTo) : this.slider.$controlsCont,
                 this.options.overVideo || this._hideOnvideoStarts(),
                 this.options.hideUnder && (t(window).bind("resize", {
                     that: this
                 }, this.onResize),
                     this.onResize())
             }
             ,
             e.onResize = function(t) {
                 var i = t && t.data.that || this
                     , e = window.innerWidth;
                 e <= i.options.hideUnder && !i.detached ? (i.$element.css("display", "none"),
                     i.detached = !0,
                 i.onDetach && i.onDetach()) : e >= i.options.hideUnder && i.detached && (i.detached = !1,
                     i.$element.css("display", ""),
                     i.visible(),
                 i.onAppend && i.onAppend())
             }
             ,
             e.create = function() {
                 var i = this;
                 this.options.autohide && !window._touch && (this.hide(!0),
                     this.slider.$controlsCont.mouseenter((function() {
                             i._disableAH || i.mdown || i.visible(),
                                 i.mleave = !1
                         }
                     )).mouseleave((function() {
                             i.mleave = !0,
                             i.mdown || i.hide()
                         }
                     )).mousedown((function() {
                             i.mdown = !0
                         }
                     )),
                     t(document).mouseup((function() {
                             i.mdown && i.mleave && i.hide(),
                                 i.mdown = !1
                         }
                     )))
             }
             ,
             e._hideOnvideoStarts = function() {
                 var t = this;
                 slider.api.addEventListener(MSSliderEvent.VIDEO_PLAY, (function() {
                         t._disableAH = !0,
                             t.hide()
                     }
                 )),
                     slider.api.addEventListener(MSSliderEvent.VIDEO_CLOSE, (function() {
                             t._disableAH = !1,
                                 t.visible()
                         }
                     ))
             }
             ,
             e.hide = function(t) {
                 t ? this.$element.css("opacity", 0) : CTween.fadeOut(this.$element, 400, !1),
                     this.$element.addClass("ms-ctrl-hide")
             }
             ,
             e.visible = function() {
                 this.detached || (CTween.fadeIn(this.$element, 400),
                     this.$element.removeClass("ms-ctrl-hide"))
             }
             ,
             e.destroy = function() {
                 this.options.hideUnder && t(window).unbind("resize", this.onResize)
             }
             ,
             window.BaseControl = i
     }(jQuery),
     function(t) {
         "use strict";
         var i, e, s = function(i) {
             BaseControl.call(this),
                 t.extend(this.options, i)
         };
         s.extend(BaseControl),
             i = s.prototype,
             e = BaseControl.prototype,
             i.setup = function() {
                 var i = this;
                 e.setup.call(this),
                     this.$next = t("<div></div>").addClass(this.options.prefix + "nav-next").appendTo(this.cont).bind("click", (function() {
                             i.slider.options.loop || i.slider.api.index() !== i.slider.api.count() - 1 ? i.slider.api.next() : i.slider.view.controller.bounce(10)
                         }
                     )),
                     this.$prev = t("<div></div>").addClass(this.options.prefix + "nav-prev").appendTo(this.cont).bind("click", (function() {
                             i.slider.options.loop || 0 !== i.slider.api.index() ? i.slider.api.previous() : i.slider.view.controller.bounce(-10)
                         }
                     ))
             }
             ,
             i.hide = function(t) {
                 if (t)
                     return this.$prev.css("opacity", 0),
                         void this.$next.css("opacity", 0);
                 CTween.fadeOut(this.$prev, 400, !1),
                     CTween.fadeOut(this.$next, 400, !1),
                     this.$prev.addClass("ms-ctrl-hide"),
                     this.$next.addClass("ms-ctrl-hide")
             }
             ,
             i.visible = function() {
                 CTween.fadeIn(this.$prev, 400),
                     CTween.fadeIn(this.$next, 400),
                     this.$prev.removeClass("ms-ctrl-hide"),
                     this.$next.removeClass("ms-ctrl-hide")
             }
             ,
             i.destroy = function() {
                 this.$next.remove(),
                     this.$prev.remove()
             }
             ,
             window.MSArrows = s,
             MSSlideController.registerControl("arrows", s)
     }(jQuery),
     function(t) {
         "use strict";
         var i, e, s = function(i) {
             BaseControl.call(this),
                 this.options.dir = "h",
                 this.options.wheel = "v" === i.dir,
                 this.options.arrows = !0,
                 this.options.speed = 17,
                 this.options.align = null,
                 this.options.inset = !1,
                 this.options.margin = 10,
                 this.options.space = 10,
                 this.options.width = 100,
                 this.options.height = 100,
                 this.options.type = "thumbs",
                 t.extend(this.options, i),
                 this.thumbs = [],
                 this.index_count = 0,
                 this.__dimen = "h" === this.options.dir ? "width" : "height",
                 this.__alignsize = "h" === this.options.dir ? "height" : "width",
                 this.__jdimen = "h" === this.options.dir ? "outerWidth" : "outerHeight",
                 this.__pos = "h" === this.options.dir ? "left" : "top",
                 this.click_enable = !0
         };
         s.extend(BaseControl),
             i = s.prototype,
             e = BaseControl.prototype,
             i.setup = function() {
                 var i, s;
                 this.$element = t("<div></div>").addClass(this.options.prefix + "thumb-list"),
                 "tabs" === this.options.type && this.$element.addClass(this.options.prefix + "tabs"),
                     this.$element.addClass("ms-dir-" + this.options.dir),
                     e.setup.call(this),
                     this.slider.$controlsCont === this.cont ? this.$element.appendTo(this.slider.$element) : this.$element.appendTo(this.cont),
                     this.$thumbscont = t("<div></div>").addClass("ms-thumbs-cont").appendTo(this.$element),
                 this.options.arrows && (i = this,
                     this.$fwd = t("<div></div>").addClass("ms-thumblist-fwd").appendTo(this.$element).click((function() {
                             i.controller.push(-15)
                         }
                     )),
                     this.$bwd = t("<div></div>").addClass("ms-thumblist-bwd").appendTo(this.$element).click((function() {
                             i.controller.push(15)
                         }
                     ))),
                 !this.options.insetTo && this.options.align && (s = this.options.align,
                     this.options.inset ? this.$element.css(s, this.options.margin) : (this.slider.api.addEventListener(MSSliderEvent.RESERVED_SPACE_CHANGE, this.align, this),
                         this.align()),
                     "v" === this.options.dir ? this.$element.width(this.options.width) : this.$element.height(this.options.height))
             }
             ,
             i.onAppend = function() {
                 this.options.insetTo || !this.options.align || this.options.inset || this.slider._realignControls()
             }
             ,
             i.onDetach = function() {
                 this.options.insetTo || !this.options.align || this.options.inset || this.slider._realignControls()
             }
             ,
             i.align = function() {
                 if (!this.detached) {
                     var t = this.options.align
                         , i = this.slider.reserveSpace(t, this.options[this.__alignsize] + 2 * this.options.margin);
                     this.$element.css(t, -i - this.options[this.__alignsize] - this.options.margin)
                 }
             }
             ,
             i.slideAction = function(i) {
                 var e = t(i.$element.find(".ms-thumb"))
                     , s = this
                     , n = t("<div></div>").addClass("ms-thumb-frame").append(e).append(t('<div class="ms-thumb-ol"></div>')).bind("click", (function() {
                         s.changeSlide(n)
                     }
                 ));
                 this.options.align && n.width(this.options.width).height(this.options.height).css("margin-" + ("v" === this.options.dir ? "bottom" : "right"), this.options.space),
                     n[0].index = this.index_count++,
                     this.$thumbscont.append(n),
                 t.browser.msie && e.on("dragstart", (function(t) {
                         t.preventDefault()
                     }
                 )),
                     this.thumbs.push(n)
             }
             ,
             i.create = function() {
                 var i;
                 e.create.call(this),
                     this.__translate_end = window._css3d ? " translateZ(0px)" : "",
                     this.controller = new Controller(0,0,{
                         snappingMinSpeed: 2,
                         friction: (100 - .5 * this.options.speed) / 100
                     }),
                     this.controller.renderCallback("h" === this.options.dir ? this._hMove : this._vMove, this),
                     i = this,
                     this.resize_listener = function() {
                         i.__resize()
                     }
                     ,
                     t(window).bind("resize", this.resize_listener),
                     this.thumbSize = this.thumbs[0][this.__jdimen](!0),
                     this.setupSwipe(),
                     this.__resize(),
                     i = this,
                 this.options.wheel && (this.wheellistener = function(t) {
                     var e = window.event || t.orginalEvent || t
                         , s = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
                     return i.controller.push(10 * -s),
                         !1
                 }
                     ,
                     t.browser.mozilla ? this.$element[0].addEventListener("DOMMouseScroll", this.wheellistener) : this.$element.bind("mousewheel", this.wheellistener)),
                     this.slider.api.addEventListener(MSSliderEvent.CHANGE_START, this.update, this),
                     this.cindex = this.slider.api.index(),
                     this.select(this.thumbs[this.cindex])
             }
             ,
             i._hMove = function(t, i) {
                 this.__contPos = i,
                     window._cssanim ? this.$thumbscont[0].style[window._jcsspfx + "Transform"] = "translateX(" + -i + "px)" + this.__translate_end : this.$thumbscont[0].style.left = -i + "px"
             }
             ,
             i._vMove = function(t, i) {
                 this.__contPos = i,
                     window._cssanim ? this.$thumbscont[0].style[window._jcsspfx + "Transform"] = "translateY(" + -i + "px)" + this.__translate_end : this.$thumbscont[0].style.top = -i + "px"
             }
             ,
             i.setupSwipe = function() {
                 this.swipeControl = new averta.TouchSwipe(this.$element),
                     this.swipeControl.swipeType = "h" === this.options.dir ? "horizontal" : "vertical";
                 var t = this;
                 this.swipeControl.onSwipe = "h" === this.options.dir ? function(i) {
                         t.horizSwipeMove(i)
                     }
                     : function(i) {
                         t.vertSwipeMove(i)
                     }
             }
             ,
             i.vertSwipeMove = function(t) {
                 var i;
                 this.dTouch || ("start" === (i = t.phase) ? this.controller.stop() : "move" === i ? this.controller.drag(t.moveY) : ("end" === i || "cancel" === i) && (Math.abs(t.distanceY / t.duration * 50 / 3) > .1 ? this.controller.push(-t.distanceY / t.duration * 50 / 3) : (this.click_enable = !0,
                     this.controller.cancel())))
             }
             ,
             i.horizSwipeMove = function(t) {
                 var i;
                 this.dTouch || ("start" === (i = t.phase) ? (this.controller.stop(),
                     this.click_enable = !1) : "move" === i ? this.controller.drag(t.moveX) : ("end" === i || "cancel" === i) && (Math.abs(t.distanceX / t.duration * 50 / 3) > .1 ? this.controller.push(-t.distanceX / t.duration * 50 / 3) : (this.click_enable = !0,
                     this.controller.cancel())))
             }
             ,
             i.update = function() {
                 var t = this.slider.api.index();
                 this.cindex !== t && (null != this.cindex && this.unselect(this.thumbs[this.cindex]),
                     this.cindex = t,
                     this.select(this.thumbs[this.cindex]),
                 this.dTouch || this.updateThumbscroll())
             }
             ,
             i.updateThumbscroll = function() {
                 var t, i = this.thumbSize * this.cindex;
                 if (NaN == this.controller.value && (this.controller.value = 0),
                     !(i - this.controller.value < 0))
                     return i + this.thumbSize - this.controller.value > this.$element[this.__dimen]() ? (t = this.cindex - Math.floor(this.$element[this.__dimen]() / this.thumbSize) + 1,
                         void this.controller.gotoSnap(t, !0)) : void 0;
                 this.controller.gotoSnap(this.cindex, !0)
             }
             ,
             i.changeSlide = function(t) {
                 this.click_enable && this.cindex !== t[0].index && this.slider.api.gotoSlide(t[0].index)
             }
             ,
             i.unselect = function(t) {
                 t.removeClass("ms-thumb-frame-selected")
             }
             ,
             i.select = function(t) {
                 t.addClass("ms-thumb-frame-selected")
             }
             ,
             i.__resize = function() {
                 var t, i = this.$element[this.__dimen]();
                 this.ls !== i && (this.ls = i,
                     this.thumbSize = this.thumbs[0][this.__jdimen](!0),
                     t = this.slider.api.count() * this.thumbSize,
                     this.$thumbscont[0].style[this.__dimen] = t + "px",
                     t <= i ? (this.dTouch = !0,
                         this.controller.stop(),
                         this.$thumbscont[0].style[this.__pos] = .5 * (i - t) + "px",
                         this.$thumbscont[0].style[window._jcsspfx + "Transform"] = "") : (this.dTouch = !1,
                         this.click_enable = !0,
                         this.$thumbscont[0].style[this.__pos] = "",
                         this.controller._max_value = t - i,
                         this.controller.options.snapsize = this.thumbSize,
                         this.updateThumbscroll()))
             }
             ,
             i.destroy = function() {
                 this.options.wheel && (t.browser.mozilla ? this.$element[0].removeEventListener("DOMMouseScroll", this.wheellistener) : this.$element.unbind("mousewheel", this.wheellistener),
                     this.wheellistener = null),
                     t(window).unbind("resize", this.resize_listener),
                     this.$element.remove(),
                     this.slider.removeEventListener(MSSliderEvent.RESERVED_SPACE_CHANGE, this.align, this),
                     e.destroy()
             }
             ,
             window.MSThumblist = s,
             MSSlideController.registerControl("thumblist", s)
     }(jQuery),
     function(t) {
         "use strict";
         var i, e, s = function(i) {
             BaseControl.call(this),
                 this.options.dir = "h",
                 this.options.inset = !0,
                 this.options.margin = 10,
                 t.extend(this.options, i),
                 this.bullets = []
         };
         s.extend(BaseControl),
             i = s.prototype,
             e = BaseControl.prototype,
             i.setup = function() {
                 if (e.setup.call(this),
                     this.$element = t("<div></div>").addClass(this.options.prefix + "bullets").addClass("ms-dir-" + this.options.dir).appendTo(this.cont),
                     this.$bullet_cont = t("<div></div>").addClass("ms-bullets-count").appendTo(this.$element),
                 !this.options.insetTo && this.options.align) {
                     this.$element.css({
                         top: "auto",
                         bottom: "auto"
                     });
                     var i = this.options.align;
                     this.options.inset && this.$element.css(i, this.options.margin)
                 }
             }
             ,
             i.create = function() {
                 var i, s, n;
                 for (e.create.call(this),
                          i = this,
                          this.slider.api.addEventListener(MSSliderEvent.CHANGE_START, this.update, this),
                          this.cindex = this.slider.api.index(),
                          s = 0; s < this.slider.api.count(); ++s)
                     (n = t("<div></div>").addClass("ms-bullet"))[0].index = s,
                         n.on("click", (function() {
                                 i.changeSlide(this.index)
                             }
                         )),
                         this.$bullet_cont.append(n),
                         this.bullets.push(n);
                 "h" === this.options.dir && this.$element.width(n.outerWidth(!0) * this.slider.api.count()),
                     this.select(this.bullets[this.cindex])
             }
             ,
             i.update = function() {
                 var t = this.slider.api.index();
                 this.cindex !== t && (null != this.cindex && this.unselect(this.bullets[this.cindex]),
                     this.cindex = t,
                     this.select(this.bullets[this.cindex]))
             }
             ,
             i.changeSlide = function(t) {
                 this.cindex !== t && this.slider.api.gotoSlide(t)
             }
             ,
             i.unselect = function(t) {
                 t.removeClass("ms-bullet-selected")
             }
             ,
             i.select = function(t) {
                 t.addClass("ms-bullet-selected")
             }
             ,
             i.destroy = function() {
                 this.$element.remove()
             }
             ,
             window.MSBulltes = s,
             MSSlideController.registerControl("bullets", s)
     }(jQuery),
     function(t) {
         "use strict";
         var i, e, s = function(i) {
             BaseControl.call(this),
                 this.options.dir = "h",
                 this.options.autohide = !0,
                 this.options.width = 4,
                 this.options.color = "#3D3D3D",
                 this.options.margin = 10,
                 t.extend(this.options, i),
                 this.__dimen = "h" === this.options.dir ? "width" : "height",
                 this.__jdimen = "h" === this.options.dir ? "outerWidth" : "outerHeight",
                 this.__pos = "h" === this.options.dir ? "left" : "top",
                 this.__translate_end = window._css3d ? " translateZ(0px)" : "",
                 this.__translate_start = "h" === this.options.dir ? " translateX(" : "translateY("
         };
         s.extend(BaseControl),
             i = s.prototype,
             e = BaseControl.prototype,
             i.setup = function() {
                 if (this.$element = t("<div></div>").addClass(this.options.prefix + "sbar").addClass("ms-dir-" + this.options.dir),
                     e.setup.call(this),
                     this.slider.$controlsCont === this.cont ? this.$element.appendTo(this.slider.$element) : this.$element.appendTo(this.cont),
                     this.$bar = t("<div></div>").addClass(this.options.prefix + "bar").appendTo(this.$element),
                 this.slider.options.loop && (console.log("WARNING, MSScrollbar cannot work with looped slider."),
                     this.disable = !0,
                     this.$element.remove()),
                     "v" === this.options.dir ? this.$bar.width(this.options.width) : this.$bar.height(this.options.width),
                     this.$bar.css("background-color", this.options.color),
                 !this.options.insetTo && this.options.align) {
                     "v" === this.options.dir ? this.$element.css({
                         right: "auto",
                         left: "auto"
                     }) : this.$element.css({
                         top: "auto",
                         bottom: "auto"
                     });
                     var i = this.options.align;
                     this.options.inset ? this.$element.css(i, this.options.margin) : (this.slider.api.addEventListener(MSSliderEvent.RESERVED_SPACE_CHANGE, this.align, this),
                         this.align())
                 }
             }
             ,
             i.onAppend = function() {
                 this.options.insetTo || !this.options.align || this.options.inset || this.slider._realignControls()
             }
             ,
             i.onDetach = function() {
                 this.options.insetTo || !this.options.align || this.options.inset || this.slider._realignControls()
             }
             ,
             i.align = function() {
                 if (!this.detached) {
                     var t = this.options.align
                         , i = this.slider.reserveSpace(t, 2 * this.options.margin + this.options.width);
                     this.$element.css(t, -i - this.options.margin - this.options.width)
                 }
             }
             ,
             i.create = function() {
                 if (!this.disable) {
                     this.scroller = this.slider.api.scroller,
                         this.slider.api.view.addEventListener(MSViewEvents.SCROLL, this._update, this),
                         this.slider.api.addEventListener(MSSliderEvent.RESIZE, this._resize, this),
                         this._resize(),
                     this.options.autohide && this.$bar.css("opacity", "0")
                 }
             }
             ,
             i._resize = function() {
                 this.vdimen = this.$element[this.__dimen](),
                     this.bar_dimen = this.slider.api.view["__" + this.__dimen] * this.vdimen / this.scroller._max_value,
                     this.$bar[this.__dimen](this.bar_dimen)
             }
             ,
             i._update = function() {
                 var t, i = this.scroller.value * (this.vdimen - this.bar_dimen) / this.scroller._max_value;
                 if (this.lvalue !== i) {
                     if (this.lvalue = i,
                     this.options.autohide && (clearTimeout(this.hto),
                         this.$bar.css("opacity", "1"),
                         t = this,
                         this.hto = setTimeout((function() {
                                 t.$bar.css("opacity", "0")
                             }
                         ), 150)),
                     i < 0)
                         return void (this.$bar[0].style[this.__dimen] = this.bar_dimen + i + "px");
                     if (i > this.vdimen - this.bar_dimen && (this.$bar[0].style[this.__dimen] = this.vdimen - i + "px"),
                         window._cssanim)
                         return void (this.$bar[0].style[window._jcsspfx + "Transform"] = this.__translate_start + i + "px)" + this.__translate_end);
                     this.$bar[0].style[this.__pos] = i + "px"
                 }
             }
             ,
             i.destroy = function() {
                 this.slider.api.view.removeEventListener(MSViewEvents.SCROLL, this._update, this),
                     this.slider.api.removeEventListener(MSSliderEvent.RESIZE, this._resize, this),
                     this.slider.removeEventListener(MSSliderEvent.RESERVED_SPACE_CHANGE, this.align, this),
                     this.$element.remove(),
                     e.destroy()
             }
             ,
             window.MSScrollbar = s,
             MSSlideController.registerControl("scrollbar", s)
     }(jQuery),
     function(t) {
         "use strict";
         var i, e, s = function(i) {
             BaseControl.call(this),
                 this.options.autohide = !1,
                 this.options.width = 4,
                 this.options.color = "#FFFFFF",
                 this.options.inset = !0,
                 t.extend(this.options, i)
         };
         s.extend(BaseControl),
             i = s.prototype,
             e = BaseControl.prototype,
             i.setup = function() {
                 var i;
                 e.setup.call(this),
                     this.$element = t("<div></div>").addClass(this.options.prefix + "timerbar"),
                     e.setup.call(this),
                     this.slider.$controlsCont === this.cont ? this.$element.appendTo(this.slider.$element) : this.$element.appendTo(this.cont),
                     this.$bar = t("<div></div>").addClass("ms-time-bar").appendTo(this.$element),
                     "v" === this.options.dir ? this.$bar.width(this.options.width) : this.$bar.height(this.options.width),
                     this.$bar.css("background-color", this.options.color),
                 !this.options.insetTo && this.options.align && (this.$element.css({
                     top: "auto",
                     bottom: "auto"
                 }),
                     i = this.options.align,
                     this.options.inset ? this.$element.css(i, this.options.margin) : (this.slider.api.addEventListener(MSSliderEvent.RESERVED_SPACE_CHANGE, this.align, this),
                         this.align()))
             }
             ,
             i.onAppend = function() {
                 this.options.insetTo || !this.options.align || this.options.inset || this.slider._realignControls()
             }
             ,
             i.onDetach = function() {
                 this.options.insetTo || !this.options.align || this.options.inset || this.slider._realignControls()
             }
             ,
             i.align = function() {
                 if (!this.detached) {
                     var t = this.options.align
                         , i = this.slider.reserveSpace(t, 2 * this.options.margin + this.options.width);
                     this.$element.css(t, -i - this.options.margin - this.options.width)
                 }
             }
             ,
             i.create = function() {
                 e.create.call(this),
                     this.slider.api.addEventListener(MSSliderEvent.WATING, this._update, this),
                     this._update()
             }
             ,
             i._update = function() {
                 this.$bar[0].style.width = this.slider.api._delayProgress + "%"
             }
             ,
             i.destroy = function() {
                 this.slider.api.removeEventListener(MSSliderEvent.WATING, this._update, this),
                     this.$element.remove()
             }
             ,
             window.MSTimerbar = s,
             MSSlideController.registerControl("timebar", s)
     }(jQuery),
     function(t) {
         "use strict";
         var i, e, s = function(i) {
             BaseControl.call(this),
                 this.options.color = "#A2A2A2",
                 this.options.stroke = 10,
                 this.options.radius = 4,
                 this.options.autohide = !1,
                 t.extend(this.options, i)
         };
         s.extend(BaseControl),
             i = s.prototype,
             e = BaseControl.prototype,
             i.setup = function() {
                 if (e.setup.call(this),
                     this.$element = t("<div></div>").addClass(this.options.prefix + "ctimer").appendTo(this.cont),
                     this.$canvas = t("<canvas></canvas>").addClass("ms-ctimer-canvas").appendTo(this.$element),
                     this.$bar = t("<div></div>").addClass("ms-ctimer-bullet").appendTo(this.$element),
                     !this.$canvas[0].getContext)
                     return this.destroy(),
                         void (this.disable = !0);
                 this.ctx = this.$canvas[0].getContext("2d"),
                     this.prog = 0,
                     this.__w = 2 * (this.options.radius + this.options.stroke / 2),
                     this.$canvas[0].width = this.__w,
                     this.$canvas[0].height = this.__w
             }
             ,
             i.create = function() {
                 if (!this.disable) {
                     e.create.call(this),
                         this.slider.api.addEventListener(MSSliderEvent.WATING, this._update, this);
                     var t = this;
                     this.$element.click((function() {
                             t.slider.api.paused ? t.slider.api.resume() : t.slider.api.pause()
                         }
                     )),
                         this._update()
                 }
             }
             ,
             i._update = function() {
                 var i = this;
                 t(this).stop(!0).animate({
                     prog: .01 * this.slider.api._delayProgress
                 }, {
                     duration: 200,
                     step: function() {
                         i._draw()
                     }
                 })
             }
             ,
             i._draw = function() {
                 this.ctx.clearRect(0, 0, this.__w, this.__w),
                     this.ctx.beginPath(),
                     this.ctx.arc(.5 * this.__w, .5 * this.__w, this.options.radius, 1.5 * Math.PI, 1.5 * Math.PI + 2 * Math.PI * this.prog, !1),
                     this.ctx.strokeStyle = this.options.color,
                     this.ctx.lineWidth = this.options.stroke,
                     this.ctx.stroke()
             }
             ,
             i.destroy = function() {
                 this.disable || (t(this).stop(!0),
                     this.slider.api.removeEventListener(MSSliderEvent.WATING, this._update, this),
                     this.$element.remove())
             }
             ,
             window.MSCircleTimer = s,
             MSSlideController.registerControl("circletimer", s)
     }(jQuery),
     function(t) {
         "use strict";
         window.MSLightbox = function(i) {
             BaseControl.call(this, i),
                 this.options.autohide = !1,
                 t.extend(this.options, i),
                 this.data_list = []
         }
             ,
             MSLightbox.fadeDuratation = 400,
             MSLightbox.extend(BaseControl);
         var i = MSLightbox.prototype
             , e = BaseControl.prototype;
         i.setup = function() {
             e.setup.call(this),
                 this.$element = t("<div></div>").addClass(this.options.prefix + "lightbox-btn").appendTo(this.cont)
         }
             ,
             i.slideAction = function(i) {
                 t("<div></div>").addClass(this.options.prefix + "lightbox-btn").appendTo(i.$element).append(t(i.$element.find(".ms-lightbox")))
             }
             ,
             i.create = function() {
                 e.create.call(this)
             }
             ,
             MSSlideController.registerControl("lightbox", MSLightbox)
     }(jQuery),
     function(t) {
         "use strict";
         window.MSSlideInfo = function(i) {
             BaseControl.call(this, i),
                 this.options.autohide = !1,
                 this.options.align = null,
                 this.options.inset = !1,
                 this.options.margin = 10,
                 this.options.size = 100,
                 this.options.dir = "h",
                 t.extend(this.options, i),
                 this.data_list = []
         }
             ,
             MSSlideInfo.fadeDuratation = 400,
             MSSlideInfo.extend(BaseControl);
         var i = MSSlideInfo.prototype
             , e = BaseControl.prototype;
         i.setup = function() {
             if (this.$element = t("<div></div>").addClass(this.options.prefix + "slide-info").addClass("ms-dir-" + this.options.dir),
                 e.setup.call(this),
                 this.slider.$controlsCont === this.cont ? this.$element.appendTo(this.slider.$element) : this.$element.appendTo(this.cont),
             !this.options.insetTo && this.options.align) {
                 var i = this.options.align;
                 this.options.inset ? this.$element.css(i, this.options.margin) : (this.slider.api.addEventListener(MSSliderEvent.RESERVED_SPACE_CHANGE, this.align, this),
                     this.align()),
                     "v" === this.options.dir ? this.$element.width(this.options.size) : this.$element.css("min-height", this.options.size)
             }
         }
             ,
             i.onAppend = function() {
                 this.options.insetTo || !this.options.align || this.options.inset || this.slider._realignControls()
             }
             ,
             i.onDetach = function() {
                 this.options.insetTo || !this.options.align || this.options.inset || this.slider._realignControls()
             }
             ,
             i.align = function() {
                 if (!this.detached) {
                     var t = this.options.align
                         , i = this.slider.reserveSpace(t, this.options.size + 2 * this.options.margin);
                     this.$element.css(t, -i - this.options.size - this.options.margin)
                 }
             }
             ,
             i.slideAction = function(i) {
                 var e = t(i.$element.find(".ms-info"));
                 e.detach(),
                     this.data_list[i.index] = e
             }
             ,
             i.create = function() {
                 e.create.call(this),
                     this.slider.api.addEventListener(MSSliderEvent.CHANGE_START, this.update, this),
                     this.cindex = this.slider.api.index(),
                     this.switchEle(this.data_list[this.cindex])
             }
             ,
             i.update = function() {
                 var t = this.slider.api.index();
                 this.switchEle(this.data_list[t]),
                     this.cindex = t
             }
             ,
             i.switchEle = function(t) {
                 if (this.current_ele) {
                     var i = this;
                     return this.current_ele[0].tween && this.current_ele[0].tween.stop(!0),
                         this.current_ele[0].tween = CTween.animate(this.current_ele, MSSlideInfo.fadeDuratation, {
                             opacity: 0
                         }, {
                             complete: function() {
                                 this.detach(),
                                     this[0].tween = null
                             },
                             target: this.current_ele
                         }),
                         clearTimeout(this.tou),
                         void (this.tou = setTimeout((function() {
                                 i.__show(t)
                             }
                         ), MSSlideInfo.fadeDuratation + 200))
                 }
                 this.__show(t)
             }
             ,
             i.__show = function(t) {
                 t.appendTo(this.$element).css("opacity", "0"),
                     CTween.fadeIn(t, MSSlideInfo.fadeDuratation),
                 t[0].tween && t[0].tween.stop(!0),
                     this.current_ele = t
             }
             ,
             i.destroy = function() {
                 clearTimeout(this.tou),
                 this.current_ele && this.current_ele[0].tween.stop("true"),
                     this.$element.remove(),
                     this.slider.removeEventListener(MSSliderEvent.RESERVED_SPACE_CHANGE, this.align, this)
             }
             ,
             MSSlideController.registerControl("slideinfo", MSSlideInfo)
     	}(jQuery),
	     function() {
	         window.MSGallery = function(t, i) {
	             this.id = t,
	                 this.slider = i,
	                 this.telement = $("#" + t),
	                 this.botcont = $("<div></div>").addClass("ms-gallery-botcont").appendTo(this.telement),
	                 this.thumbcont = $("<div></div>").addClass("ms-gal-thumbcont hide-thumbs").appendTo(this.botcont),
	                 this.playbtn = $("<div></div>").addClass("ms-gal-playbtn").appendTo(this.botcont),
	                 this.thumbtoggle = $("<div></div>").addClass("ms-gal-thumbtoggle").appendTo(this.botcont),
	                 i.control("thumblist", {
	                     insertTo: this.thumbcont,
	                     autohide: !1,
	                     dir: "h"
	                 }),
	                 i.control("slidenum", {
	                     insertTo: this.botcont,
	                     autohide: !1
	                 }),
	                 i.control("slideinfo", {
	                     insertTo: this.botcont,
	                     autohide: !1
	                 }),
	                 i.control("timebar", {
	                     insertTo: this.botcont,
	                     autohide: !1
	                 }),
	                 i.control("bullets", {
	                     insertTo: this.botcont,
	                     autohide: !1
	                 })
	         }
	         ;
	         var t = MSGallery.prototype;
	         t._init = function() {
	             var t = this;
	             this.slider.api.paused || this.playbtn.addClass("btn-pause"),
	                 this.playbtn.click((function() {
	                         t.slider.api.paused ? (t.slider.api.resume(),
	                             t.playbtn.addClass("btn-pause")) : (t.slider.api.pause(),
	                             t.playbtn.removeClass("btn-pause"))
	                     }
	                 )),
	                 this.thumbtoggle.click((function() {
	                         t.vthumbs ? (t.thumbtoggle.removeClass("btn-hide"),
	                             t.vthumbs = !1,
	                             t.thumbcont.addClass("hide-thumbs")) : (t.thumbtoggle.addClass("btn-hide"),
	                             t.thumbcont.removeClass("hide-thumbs"),
	                             t.vthumbs = !0)
	                     }
	                 ))
	         }
             ,
             t.setup = function() {
                 var t = this;
                 $(document).ready((function() {
                         t._init()
                     }
                 ))
             }
     }(),
     //$(document).ready((function(t) {
          
             initialiseMasterSliders()
           }
             
      //   }
     //));
	